// import React, { useState, useEffect, useCallback, useRef } from 'react';
// import {
//   Box,
//   Button,
//   Grid,
//   IconButton,
//   Typography,
//   useTheme,
//   useMediaQuery,
//   Tabs,
//   Tab,
//   Tooltip,
//   Card,
//   CardContent,
//   Fab,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Switch,
//   FormControlLabel,
//   Alert,
//   Stack,
//   Paper,
//   Fade,
//   FormControl,
//   Select,
//   MenuItem
// } from '@mui/material';
// import {
//   CloudUpload as UploadIcon,
//   PictureAsPdf as PdfIcon,
//   Image as ImageIcon,
//   Description as DocumentIcon,
//   Delete as DeleteIcon,
//   Fullscreen as FullscreenIcon,
//   FullscreenExit as FullscreenExitIcon,
//   ZoomOut as ZoomOutIcon,
//   ZoomIn as ZoomInIcon,
//   Close as CloseIcon,
//   DragIndicator as DragIcon,
//   Settings as SettingsIcon,
//   Star as StarIcon
// } from '@mui/icons-material';
// import { Document, Page, pdfjs } from 'react-pdf';
// import 'react-pdf/dist/Page/AnnotationLayer.css';
// import 'react-pdf/dist/Page/TextLayer.css';
// import fieldTypes from '../SignatureFields';
// import { SignatureField, UploadedFile } from '../types';
// import { IoArrowBackCircleOutline } from 'react-icons/io5';
// import ConfirmationDialog from 'commonComponents/ConfirmationDialog';

// pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

// interface DocumentEditingStepProps {
//   uploadedFile: UploadedFile | null;
//   setUploadedFile: (file: UploadedFile | null) => void;
//   signatureFields: SignatureField[];
//   setSignatureFields: (
//     fields: SignatureField[] | ((prev: SignatureField[]) => SignatureField[])
//   ) => void;
//   fieldRequirements: Record<string, boolean>;
//   setFieldRequirements: (
//     requirements:
//       | Record<string, boolean>
//       | ((prev: Record<string, boolean>) => Record<string, boolean>)
//   ) => void;
//   setSuccessMessage: (message: string | null) => void;
//   onBack: () => void;
//   onNext: () => void;
// }

// const DocumentEditingStep: React.FC<DocumentEditingStepProps> = ({
//   uploadedFile,
//   setUploadedFile,
//   signatureFields,
//   setSignatureFields,
//   fieldRequirements,
//   setFieldRequirements,
//   setSuccessMessage,
//   onBack,
//   onNext
// }) => {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('md'));

//   // Local state for document editing
//   const [selectedFieldType, setSelectedFieldType] = useState<string | null>(null);
//   const [multiSelectMode, setMultiSelectMode] = useState(false);
//   const [selectedFieldTypes, setSelectedFieldTypes] = useState<string[]>([]);
//   const [showConfirmation, setShowConfirmation] = useState(false);
//   const [showMobileFieldSelector, setShowMobileFieldSelector] = useState(false);
//   const [fullScreenPdf, setFullScreenPdf] = useState(false);
//   const [activeTab, setActiveTab] = useState(0);
//   const [numPages, setNumPages] = useState<number>(0);
//   const [currentPage, setCurrentPage] = useState<number>(1);
//   const [scale, setScale] = useState<number>(1.0);
//   const [pdfError, setPdfError] = useState<string | null>(null);

//   // **NEW: PDF render trigger state**
//   const [pdfRenderTrigger, setPdfRenderTrigger] = useState(0);
//   const [isDocumentReady, setIsDocumentReady] = useState(false);

//   // Drag states
//   const [draggingFieldId, setDraggingFieldId] = useState<string | null>(null);
//   const [dragOffset, setDragOffset] = useState<{ x: number; y: number } | null>(null);
//   const [isDraggingField, setIsDraggingField] = useState(false);
//   const [initialScrollPos, setInitialScrollPos] = useState<{ x: number; y: number } | null>(null);

//   const fileInputRef = useRef<HTMLInputElement>(null);
//   const pdfContainerRef = useRef<HTMLDivElement>(null);
//   const documentRenderTimeoutRef = useRef<NodeJS.Timeout | null>(null);

//   // **NEW: Window resize handler to trigger field repositioning**
//   useEffect(() => {
//     const handleResize = () => {
//       // Debounce resize events
//       if (documentRenderTimeoutRef.current) {
//         clearTimeout(documentRenderTimeoutRef.current);
//       }
//       documentRenderTimeoutRef.current = setTimeout(() => {
//         setPdfRenderTrigger((prev) => prev + 1);
//       }, 100);
//     };

//     window.addEventListener('resize', handleResize);
//     return () => {
//       window.removeEventListener('resize', handleResize);
//       if (documentRenderTimeoutRef.current) {
//         clearTimeout(documentRenderTimeoutRef.current);
//       }
//     };
//   }, []);

//   // **NEW: Effect to trigger field repositioning when document is ready**
//   useEffect(() => {
//     if (uploadedFile && signatureFields.length > 0 && isDocumentReady) {
//       // Trigger repositioning after a short delay to ensure DOM is ready
//       const timer = setTimeout(() => {
//         setPdfRenderTrigger((prev) => prev + 1);
//       }, 200);
//       return () => clearTimeout(timer);
//     }
//   }, [uploadedFile, signatureFields.length, isDocumentReady]);

//   // Helper functions
//   const getFieldConfig = (fieldKey: string) =>
//     fieldTypes.find((f) => f.fieldKey === fieldKey) || fieldTypes[0];

//   const getFieldsByCategory = () => {
//     const grouped = fieldTypes.reduce((acc, field) => {
//       if (!acc[field.category]) acc[field.category] = [];
//       acc[field.category].push(field);
//       return acc;
//     }, {} as Record<string, typeof fieldTypes>);
//     return grouped;
//   };

//   const fileToBase64 = (file: File): Promise<string> =>
//     new Promise((resolve, reject) => {
//       const reader = new FileReader();
//       reader.onload = () => resolve(reader.result as string);
//       reader.onerror = (error) => reject(error);
//       reader.readAsDataURL(file);
//     });

//   const getFileType = (file: File): 'pdf' | 'image' | 'document' => {
//     if (file.type === 'application/pdf') return 'pdf';
//     if (file.type.startsWith('image/')) return 'image';
//     if (
//       file.type === 'application/msword' ||
//       file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
//     ) {
//       return 'document';
//     }
//     return 'document';
//   };

//   const getFileExtension = (filename: string): string => {
//     return filename.split('.').pop()?.toLowerCase() || '';
//   };

//   const getFileIcon = (type: 'pdf' | 'image' | 'document') => {
//     const iconSize = isMobile ? 16 : 20;
//     switch (type) {
//       case 'pdf':
//         return <PdfIcon sx={{ fontSize: iconSize, color: '#f44336' }} />;
//       case 'image':
//         return <ImageIcon sx={{ fontSize: iconSize, color: '#2196f3' }} />;
//       case 'document':
//         return <DocumentIcon sx={{ fontSize: iconSize, color: '#4caf50' }} />;
//       default:
//         return <DocumentIcon sx={{ fontSize: iconSize, color: '#9e9e9e' }} />;
//     }
//   };

//   const simulateUpload = (file: File): Promise<void> =>
//     new Promise((resolve) => {
//       let progress = 0;
//       const interval = setInterval(() => {
//         progress += Math.random() * 20;
//         if (progress >= 100) {
//           clearInterval(interval);
//           setTimeout(() => {
//             setSuccessMessage('File uploaded successfully!');
//             resolve();
//           }, 500);
//         }
//       }, 200);
//     });

//   const processFile = async (file: File) => {
//     const allowedMimeTypes = [
//       'application/pdf',
//       'image/jpeg',
//       'image/jpg',
//       'image/png',
//       'image/gif',
//       'image/webp',
//       'application/msword',
//       'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
//     ];

//     const allowedExtensions = ['pdf', 'doc', 'docx', 'png', 'jpg', 'jpeg', 'gif', 'webp'];
//     const fileExtension = getFileExtension(file.name);

//     if (!allowedMimeTypes.includes(file.type) && !allowedExtensions.includes(fileExtension)) {
//       setPdfError(
//         'Unsupported file type. Supported types: pdf, docx, doc, png, jpg, jpeg, gif, webp'
//       );
//       return;
//     }

//     if (file.size > 10 * 1024 * 1024) {
//       setPdfError('File size must be less than 10MB');
//       return;
//     }

//     try {
//       await simulateUpload(file);
//       const fileType = getFileType(file);
//       const preview = URL.createObjectURL(file);
//       const base64 = await fileToBase64(file);
//       setUploadedFile({ file, preview, type: fileType, base64 });
//       setIsDocumentReady(false); // Reset document ready state
//       setPdfError(null);
//     } catch (error) {
//       setPdfError('Failed to process file');
//     }
//   };

//   const handleUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
//     if (e.target.files?.length) {
//       await processFile(e.target.files[0]);
//       if (fileInputRef.current) fileInputRef.current.value = '';
//     }
//   };

//   const removeFile = () => {
//     if (uploadedFile?.preview) URL.revokeObjectURL(uploadedFile.preview);
//     setUploadedFile(null);
//     setSignatureFields([]);
//     setIsDocumentReady(false);
//     setPdfError(null);
//     if (fileInputRef.current) fileInputRef.current.value = '';
//   };

//   // **ENHANCED: Document load success with proper initialization**
//   const onDocumentLoadSuccess = ({ numPages }: { numPages: number }) => {
//     console.log('Document loaded successfully, pages:', numPages);
//     setNumPages(numPages);
//     setIsDocumentReady(false); // Will be set to true after first page renders
//   };

//   // **ENHANCED: Page render success handler**
//   const handlePageRenderSuccess = useCallback(() => {
//     console.log('Page rendered successfully');
//     setIsDocumentReady(true);
//     // Trigger field repositioning after page renders
//     setPdfRenderTrigger((prev) => prev + 1);
//   }, []);

//   // Enhanced handlePageClick with percentage-based positioning
//   const handlePageClick = useCallback(
//     (event: React.MouseEvent<HTMLDivElement>) => {
//       if (
//         (!selectedFieldType && selectedFieldTypes.length === 0) ||
//         !pdfContainerRef.current ||
//         draggingFieldId
//       )
//         return;

//       const rect = pdfContainerRef.current.getBoundingClientRect();
//       const scrollTop = pdfContainerRef.current.scrollTop;
//       const scrollLeft = pdfContainerRef.current.scrollLeft;

//       // Get document element for size calculation
//       const docElement = pdfContainerRef.current.querySelector('canvas, img');
//       if (!docElement) return;

//       const docWidth = docElement.clientWidth;
//       const docHeight = docElement.clientHeight;

//       // Calculate click position relative to document
//       const x = event.clientX - rect.left + scrollLeft;
//       const y = event.clientY - rect.top + scrollTop;

//       // Calculate percentage positions
//       const xPercent = (x / docWidth) * 100;
//       const yPercent = (y / docHeight) * 100;

//       const getDefaultDimensions = (fieldKey: string) => {
//         switch (fieldKey) {
//           case 'signature':
//             return { width: isMobile ? 120 : 140, height: isMobile ? 35 : 40 };
//           case 'initials':
//             return { width: isMobile ? 60 : 80, height: isMobile ? 25 : 30 };
//           case 'checkbox':
//             return { width: 16, height: 16 };
//           case 'address':
//             return { width: isMobile ? 140 : 160, height: isMobile ? 50 : 60 };
//           case 'date':
//           case 'expiry':
//             return { width: isMobile ? 80 : 100, height: isMobile ? 20 : 25 };
//           default:
//             return { width: isMobile ? 80 : 100, height: isMobile ? 20 : 25 };
//         }
//       };

//       const pageNumber = uploadedFile?.type === 'image' ? 1 : currentPage;

//       // Handle multi-select mode for mobile
//       if (selectedFieldTypes.length > 0) {
//         const newFields: SignatureField[] = [];
//         selectedFieldTypes.forEach((fieldKey, index) => {
//           const dimensions = getDefaultDimensions(fieldKey);
//           const config = getFieldConfig(fieldKey);
//           const fieldId = `${fieldKey}-${Date.now()}-${Math.random()}-${index}`;
//           const fieldXPercent = xPercent + index * 2;
//           const fieldYPercent = yPercent + index * 1;

//           const newField: SignatureField = {
//             id: fieldId,
//             type: config.type,
//             x: (fieldXPercent / 100) * docWidth,
//             y: (fieldYPercent / 100) * docHeight,
//             pageNumber: pageNumber,
//             value: '',
//             width: dimensions.width,
//             height: dimensions.height,
//             isRequired: config.defaultRequired,
//             fieldLabel: config.label,
//             xPercent: fieldXPercent,
//             yPercent: fieldYPercent,
//             widthPercent: (dimensions.width / docWidth) * 100,
//             heightPercent: (dimensions.height / docHeight) * 100
//           };
//           newFields.push(newField);
//           setFieldRequirements((prev) => ({
//             ...prev,
//             [fieldId]: config.defaultRequired
//           }));
//         });
//         setSignatureFields([...signatureFields, ...newFields]);
//         setSelectedFieldTypes([]);
//         setMultiSelectMode(false);
//         if (isMobile) setShowMobileFieldSelector(false);
//       } else if (selectedFieldType) {
//         // Handle single field placement
//         const dimensions = getDefaultDimensions(selectedFieldType);
//         const config = getFieldConfig(selectedFieldType);
//         const fieldId = `${selectedFieldType}-${Date.now()}-${Math.random()}`;

//         const newField: SignatureField = {
//           id: fieldId,
//           type: config.type,
//           x: (xPercent / 100) * docWidth,
//           y: (yPercent / 100) * docHeight,
//           pageNumber: pageNumber,
//           value: '',
//           width: dimensions.width,
//           height: dimensions.height,
//           isRequired: config.defaultRequired,
//           fieldLabel: config.label,
//           xPercent: xPercent,
//           yPercent: yPercent,
//           widthPercent: (dimensions.width / docWidth) * 100,
//           heightPercent: (dimensions.height / docHeight) * 100
//         };
//         setSignatureFields([...signatureFields, newField]);
//         setFieldRequirements((prev) => ({
//           ...prev,
//           [fieldId]: config.defaultRequired
//         }));
//         setSelectedFieldType(null);
//       }
//     },
//     [
//       selectedFieldType,
//       selectedFieldTypes,
//       currentPage,
//       signatureFields,
//       draggingFieldId,
//       isMobile,
//       uploadedFile?.type,
//       setSignatureFields,
//       setFieldRequirements
//     ]
//   );

//   const addSignatureField = (fieldKey: string) => {
//     if (multiSelectMode) {
//       setSelectedFieldTypes((prev) =>
//         prev.includes(fieldKey) ? prev.filter((t) => t !== fieldKey) : [...prev, fieldKey]
//       );
//     } else {
//       setSelectedFieldType(fieldKey);
//       setDraggingFieldId(null);
//       setIsDraggingField(false);
//       if (isMobile) setShowMobileFieldSelector(false);
//     }
//   };

//   // Enhanced drag functionality to handle both PDF and images with touch support
//   const handleFieldMouseDown = (fieldId: string, event: React.MouseEvent<HTMLDivElement>) => {
//     if (selectedFieldType || selectedFieldTypes.length > 0) return;
//     event.stopPropagation();
//     event.preventDefault();

//     setDraggingFieldId(fieldId);
//     setIsDraggingField(true);

//     const field = signatureFields.find((f) => f.id === fieldId);
//     if (field && pdfContainerRef.current) {
//       const rect = pdfContainerRef.current.getBoundingClientRect();
//       const scrollTop = pdfContainerRef.current.scrollTop;
//       const scrollLeft = pdfContainerRef.current.scrollLeft;

//       setInitialScrollPos({ x: scrollLeft, y: scrollTop });

//       // Use different scaling for images vs PDFs
//       const effectiveScale = uploadedFile?.type === 'image' ? 1.0 : scale;
//       setDragOffset({
//         x: event.clientX - rect.left - field.x * effectiveScale + scrollLeft,
//         y: event.clientY - rect.top - field.y * effectiveScale + scrollTop
//       });
//     }
//   };

//   // Touch event handler for mobile devices
//   const handleFieldTouchStart = (fieldId: string, event: React.TouchEvent<HTMLDivElement>) => {
//     if (selectedFieldType || selectedFieldTypes.length > 0) return;
//     event.stopPropagation();
//     event.preventDefault();

//     const touch = event.touches[0];
//     setDraggingFieldId(fieldId);
//     setIsDraggingField(true);

//     const field = signatureFields.find((f) => f.id === fieldId);
//     if (field && pdfContainerRef.current) {
//       const rect = pdfContainerRef.current.getBoundingClientRect();
//       const scrollTop = pdfContainerRef.current.scrollTop;
//       const scrollLeft = pdfContainerRef.current.scrollLeft;

//       setInitialScrollPos({ x: scrollLeft, y: scrollTop });

//       const effectiveScale = uploadedFile?.type === 'image' ? 1.0 : scale;
//       setDragOffset({
//         x: touch.clientX - rect.left - field.x * effectiveScale + scrollLeft,
//         y: touch.clientY - rect.top - field.y * effectiveScale + scrollTop
//       });
//     }
//   };

//   const handleFieldMouseMove = useCallback(
//     (event: React.MouseEvent<HTMLDivElement>) => {
//       if (
//         !draggingFieldId ||
//         !dragOffset ||
//         !pdfContainerRef.current ||
//         !isDraggingField ||
//         !initialScrollPos
//       )
//         return;
//       event.preventDefault();

//       const rect = pdfContainerRef.current.getBoundingClientRect();
//       const currentScrollTop = pdfContainerRef.current.scrollTop;
//       const currentScrollLeft = pdfContainerRef.current.scrollLeft;

//       const scrollDeltaX = currentScrollLeft - initialScrollPos.x;
//       const scrollDeltaY = currentScrollTop - initialScrollPos.y;

//       // Get actual document size
//       let docWidth = 1;
//       let docHeight = 1;
//       if (pdfContainerRef.current) {
//         const docElement = pdfContainerRef.current.querySelector('canvas, img');
//         if (docElement) {
//           docWidth = docElement.clientWidth;
//           docHeight = docElement.clientHeight;
//         }
//       }

//       // Calculate new position in pixels relative to document
//       const newX = event.clientX - rect.left - dragOffset.x + currentScrollLeft - scrollDeltaX;
//       const newY = event.clientY - rect.top - dragOffset.y + currentScrollTop - scrollDeltaY;

//       // Constrain within document bounds
//       const field = signatureFields.find((f) => f.id === draggingFieldId);
//       const fieldWidth = field?.widthPercent ? (field.widthPercent / 100) * docWidth : 100;
//       const fieldHeight = field?.heightPercent ? (field.heightPercent / 100) * docHeight : 25;
//       const constrainedX = Math.max(0, Math.min(newX, docWidth - fieldWidth));
//       const constrainedY = Math.max(0, Math.min(newY, docHeight - fieldHeight));

//       // Convert to percent-based coordinates
//       const xPercent = (constrainedX / docWidth) * 100;
//       const yPercent = (constrainedY / docHeight) * 100;

//       // Use requestAnimationFrame for smoother updates
//       window.requestAnimationFrame(() => {
//         setSignatureFields((prevFields: SignatureField[]) =>
//           prevFields.map((field: SignatureField) =>
//             field.id === draggingFieldId ? { ...field, xPercent, yPercent } : field
//           )
//         );
//       });
//     },
//     [
//       draggingFieldId,
//       dragOffset,
//       scale,
//       isDraggingField,
//       signatureFields,
//       initialScrollPos,
//       uploadedFile?.type,
//       setSignatureFields
//     ]
//   );

//   // Touch move handler for mobile
//   const handleFieldTouchMove = useCallback(
//     (event: React.TouchEvent<HTMLDivElement>) => {
//       if (
//         !draggingFieldId ||
//         !dragOffset ||
//         !pdfContainerRef.current ||
//         !isDraggingField ||
//         !initialScrollPos
//       )
//         return;
//       event.preventDefault();

//       const touch = event.touches[0];
//       const container = pdfContainerRef.current;
//       const rect = container.getBoundingClientRect();
//       const currentScrollTop = container.scrollTop;
//       const currentScrollLeft = container.scrollLeft;

//       const scrollDeltaX = currentScrollLeft - initialScrollPos.x;
//       const scrollDeltaY = currentScrollTop - initialScrollPos.y;

//       // Get actual document size
//       let docWidth = 1;
//       let docHeight = 1;
//       if (container) {
//         const docElement = container.querySelector('canvas, img');
//         if (docElement) {
//           docWidth = docElement.clientWidth;
//           docHeight = docElement.clientHeight;
//         }
//       }

//       // Calculate new position in pixels relative to document
//       const newX = touch.clientX - rect.left - dragOffset.x + currentScrollLeft - scrollDeltaX;
//       const newY = touch.clientY - rect.top - dragOffset.y + currentScrollTop - scrollDeltaY;

//       // Constrain within document bounds
//       const field = signatureFields.find((f) => f.id === draggingFieldId);
//       const fieldWidth = field?.widthPercent ? (field.widthPercent / 100) * docWidth : 100;
//       const fieldHeight = field?.heightPercent ? (field.heightPercent / 100) * docHeight : 25;
//       const constrainedX = Math.max(0, Math.min(newX, docWidth - fieldWidth));
//       const constrainedY = Math.max(0, Math.min(newY, docHeight - fieldHeight));

//       // Convert to percent-based coordinates
//       const xPercent = (constrainedX / docWidth) * 100;
//       const yPercent = (constrainedY / docHeight) * 100;

//       window.requestAnimationFrame(() => {
//         setSignatureFields((prevFields: SignatureField[]) =>
//           prevFields.map((field: SignatureField) =>
//             field.id === draggingFieldId ? { ...field, xPercent, yPercent } : field
//           )
//         );
//       });
//     },
//     [
//       draggingFieldId,
//       dragOffset,
//       scale,
//       isDraggingField,
//       signatureFields,
//       initialScrollPos,
//       uploadedFile?.type,
//       setSignatureFields
//     ]
//   );

//   const handleFieldMouseUp = useCallback(() => {
//     setDraggingFieldId(null);
//     setDragOffset(null);
//     setIsDraggingField(false);
//     setInitialScrollPos(null);
//   }, []);

//   useEffect(() => {
//     if (isDraggingField) {
//       const handleGlobalMouseMove = (e: MouseEvent) => {
//         if (!draggingFieldId || !dragOffset || !pdfContainerRef.current || !initialScrollPos)
//           return;

//         const rect = pdfContainerRef.current.getBoundingClientRect();
//         const currentScrollTop = pdfContainerRef.current.scrollTop;
//         const currentScrollLeft = pdfContainerRef.current.scrollLeft;

//         const scrollDeltaX = currentScrollLeft - initialScrollPos.x;
//         const scrollDeltaY = currentScrollTop - initialScrollPos.y;

//         // Use different scaling for images vs PDFs
//         const effectiveScale = uploadedFile?.type === 'image' ? 1.0 : scale;

//         const newX =
//           (e.clientX - rect.left - dragOffset.x + currentScrollLeft - scrollDeltaX) /
//           effectiveScale;
//         const newY =
//           (e.clientY - rect.top - dragOffset.y + currentScrollTop - scrollDeltaY) / effectiveScale;

//         const containerWidth = pdfContainerRef.current.scrollWidth / effectiveScale;
//         const containerHeight = pdfContainerRef.current.scrollHeight / effectiveScale;
//         const field = signatureFields.find((f) => f.id === draggingFieldId);
//         const fieldWidth = field?.width || 100;
//         const fieldHeight = field?.height || 25;

//         const constrainedX = Math.max(0, Math.min(newX, containerWidth - fieldWidth));
//         const constrainedY = Math.max(0, Math.min(newY, containerHeight - fieldHeight));

//         setSignatureFields((prevFields: SignatureField[]) =>
//           prevFields.map((field: SignatureField) =>
//             field.id === draggingFieldId ? { ...field, x: constrainedX, y: constrainedY } : field
//           )
//         );
//       };

//       const handleGlobalTouchMove = (e: TouchEvent) => {
//         if (!draggingFieldId || !dragOffset || !pdfContainerRef.current || !initialScrollPos)
//           return;

//         const touch = e.touches[0];
//         const container = pdfContainerRef.current;
//         const rect = container.getBoundingClientRect();
//         const currentScrollTop = container.scrollTop;
//         const currentScrollLeft = container.scrollLeft;

//         const scrollDeltaX = currentScrollLeft - initialScrollPos.x;
//         const scrollDeltaY = currentScrollTop - initialScrollPos.y;

//         const effectiveScale = uploadedFile?.type === 'image' ? 1.0 : scale;

//         const newX =
//           (touch.clientX - rect.left - dragOffset.x + currentScrollLeft - scrollDeltaX) /
//           effectiveScale;
//         const newY =
//           (touch.clientY - rect.top - dragOffset.y + currentScrollTop - scrollDeltaY) /
//           effectiveScale;

//         const containerWidth = container.scrollWidth / effectiveScale;
//         const containerHeight = container.scrollHeight / effectiveScale;
//         const field = signatureFields.find((f) => f.id === draggingFieldId);
//         const fieldWidth = field?.width || 100;
//         const fieldHeight = field?.height || 25;

//         const constrainedX = Math.max(0, Math.min(newX, containerWidth - fieldWidth));
//         const constrainedY = Math.max(0, Math.min(newY, containerHeight - fieldHeight));

//         setSignatureFields((prevFields: SignatureField[]) =>
//           prevFields.map((field: SignatureField) =>
//             field.id === draggingFieldId ? { ...field, x: constrainedX, y: constrainedY } : field
//           )
//         );
//       };

//       const handleGlobalMouseUp = () => {
//         handleFieldMouseUp();
//       };

//       document.addEventListener('mousemove', handleGlobalMouseMove);
//       document.addEventListener('mouseup', handleGlobalMouseUp);
//       document.addEventListener('touchmove', handleGlobalTouchMove, { passive: false });
//       document.addEventListener('touchend', handleGlobalMouseUp);

//       return () => {
//         document.removeEventListener('mousemove', handleGlobalMouseMove);
//         document.removeEventListener('mouseup', handleGlobalMouseUp);
//         document.removeEventListener('touchmove', handleGlobalTouchMove);
//         document.removeEventListener('touchend', handleGlobalMouseUp);
//       };
//     }
//   }, [
//     isDraggingField,
//     draggingFieldId,
//     dragOffset,
//     scale,
//     handleFieldMouseUp,
//     signatureFields,
//     initialScrollPos,
//     uploadedFile?.type,
//     setSignatureFields
//   ]);

//   // Prevent scroll during drag on mobile
//   useEffect(() => {
//     if (isDraggingField && isMobile && pdfContainerRef.current) {
//       const container = pdfContainerRef.current;
//       const originalOverflow = container.style.overflow;
//       const originalTouchAction = document.body.style.touchAction;

//       container.style.overflow = 'hidden';
//       document.body.style.touchAction = 'none';

//       return () => {
//         container.style.overflow = originalOverflow;
//         document.body.style.touchAction = originalTouchAction;
//       };
//     }
//   }, [isDraggingField, isMobile]);

//   const removeSignatureField = (fieldId: string) => {
//     setSignatureFields(signatureFields.filter((field) => field.id !== fieldId));
//     setFieldRequirements((prev) => {
//       const updated = { ...prev };
//       delete updated[fieldId];
//       return updated;
//     });
//   };

//   const toggleFieldRequirement = (fieldId: string) => {
//     setFieldRequirements((prev) => ({
//       ...prev,
//       [fieldId]: !prev[fieldId]
//     }));
//     setSignatureFields((prev: SignatureField[]) =>
//       prev.map((field: SignatureField) =>
//         field.id === fieldId ? { ...field, isRequired: !fieldRequirements[fieldId] } : field
//       )
//     );
//   };

//   const toggleFullScreen = () => setFullScreenPdf((prev) => !prev);

//   // **ENHANCED: Signature field rendering with improved positioning (depends on pdfRenderTrigger)**
//   const renderSignatureField = useCallback(
//     (field: SignatureField) => {
//       const config = fieldTypes.find((f) => f.label === field.fieldLabel) || fieldTypes[0];
//       const isBeingDragged = draggingFieldId === field.id;

//       // Get actual document size
//       let docWidth = 1;
//       let docHeight = 1;
//       if (pdfContainerRef.current) {
//         const docElement = pdfContainerRef.current.querySelector('canvas, img');
//         if (docElement) {
//           docWidth = docElement.clientWidth;
//           docHeight = docElement.clientHeight;
//         }
//       }

//       const fieldWidth = (field.widthPercent / 100) * docWidth;
//       const fieldHeight = (field.heightPercent / 100) * docHeight;
//       const left = (field.xPercent / 100) * docWidth;
//       const top = (field.yPercent / 100) * docHeight;
//       const isRequired = fieldRequirements[field.id] || false;

//       return (
//         <Tooltip
//           key={field.id}
//           title={`${config.label} (${field.type}) - ${
//             isRequired ? 'Required' : 'Optional'
//           } - Drag to move, click buttons to modify`}
//           placement="top"
//         >
//           <Box
//             sx={{
//               position: 'absolute',
//               left,
//               top,
//               bgcolor: isBeingDragged ? 'rgba(25,118,210,0.1)' : 'rgba(255,255,255,0.95)',
//               border: `2px solid ${config.color}`,
//               borderRadius: 1,
//               p: isMobile ? 0.5 : 0.75,
//               width: fieldWidth,
//               height: fieldHeight,
//               cursor: isBeingDragged ? 'grabbing' : 'grab',
//               zIndex: isBeingDragged ? 1000 : 100,
//               boxShadow: isBeingDragged
//                 ? '0 8px 16px rgba(0,0,0,0.3)'
//                 : '0 2px 8px rgba(0,0,0,0.15)',
//               transition: isBeingDragged ? 'none' : 'all 0.2s ease',
//               '&:hover': {
//                 boxShadow: '0 4px 12px rgba(0,0,0,0.25)',
//                 '& .field-actions': { opacity: 1 }
//               },
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               flexDirection: config.fieldKey === 'checkbox' ? 'row' : 'column',
//               userSelect: 'none'
//             }}
//             onMouseDown={(e) => handleFieldMouseDown(field.id, e)}
//             onTouchStart={(e) => handleFieldTouchStart(field.id, e)}
//           >
//             <Box
//               sx={{
//                 display: 'flex',
//                 alignItems: 'center',
//                 gap: config.fieldKey === 'checkbox' ? 0.5 : 0.75,
//                 flexDirection: 'row',
//                 pointerEvents: 'none'
//               }}
//             >
//               <Box sx={{ fontSize: isMobile ? '12px' : '14px', color: config.color }}>
//                 {React.cloneElement(config.icon as React.ReactElement, {
//                   fontSize: 'inherit'
//                 })}
//               </Box>
//               {config.fieldKey !== 'checkbox' && (
//                 <Typography
//                   variant="caption"
//                   sx={{
//                     fontSize: isMobile ? '8px' : '10px',
//                     fontWeight: 600,
//                     color: config.color,
//                     lineHeight: 1.2,
//                     display: 'flex',
//                     alignItems: 'center'
//                   }}
//                 >
//                   {config.label}{' '}
//                   <span style={{ color: '#999', fontWeight: 400 }}>({field.type})</span>
//                 </Typography>
//               )}
//             </Box>

//             {isRequired && (
//               <StarIcon
//                 sx={{
//                   fontSize: '10px',
//                   color: '#f44336',
//                   position: 'absolute',
//                   top: -4,
//                   right: -4
//                 }}
//               />
//             )}

//             <DragIcon
//               sx={{
//                 fontSize: isMobile ? '10px' : '12px',
//                 color: config.color,
//                 opacity: 0.6,
//                 position: 'absolute',
//                 bottom: 2,
//                 right: 2,
//                 pointerEvents: 'none'
//               }}
//             />

//             <Box
//               className="field-actions"
//               sx={{
//                 position: 'absolute',
//                 top: -8,
//                 right: -8,
//                 opacity: 0,
//                 transition: 'opacity 0.2s ease',
//                 display: 'flex',
//                 gap: 0.5
//               }}
//             >
//               <IconButton
//                 size="small"
//                 sx={{
//                   width: 18,
//                   height: 18,
//                   bgcolor: isRequired ? 'warning.main' : 'info.main',
//                   color: 'white',
//                   fontSize: '10px',
//                   '&:hover': {
//                     bgcolor: isRequired ? 'warning.dark' : 'info.dark',
//                     transform: 'scale(1.1)'
//                   }
//                 }}
//                 onClick={(e) => {
//                   e.stopPropagation();
//                   toggleFieldRequirement(field.id);
//                 }}
//                 title={isRequired ? 'Make Optional' : 'Make Required'}
//               >
//                 <StarIcon sx={{ fontSize: '8px' }} />
//               </IconButton>
//               <IconButton
//                 size="small"
//                 sx={{
//                   width: 18,
//                   height: 18,
//                   bgcolor: 'error.main',
//                   color: 'white',
//                   fontSize: '10px',
//                   '&:hover': {
//                     bgcolor: 'error.dark',
//                     transform: 'scale(1.1)'
//                   }
//                 }}
//                 onClick={(e) => {
//                   e.stopPropagation();
//                   removeSignatureField(field.id);
//                 }}
//               >
//                 <CloseIcon sx={{ fontSize: '8px' }} />
//               </IconButton>
//             </Box>
//           </Box>
//         </Tooltip>
//       );
//     },
//     [
//       fieldRequirements,
//       draggingFieldId,
//       isMobile,
//       handleFieldMouseDown,
//       handleFieldTouchStart,
//       toggleFieldRequirement,
//       removeSignatureField,
//       pdfRenderTrigger // **NEW: Added as dependency**
//     ]
//   );

//   // Enhanced renderPageThumbnails with fixed positioning and vertical aspect ratio
//   const renderPageThumbnails = () => {
//     if (!uploadedFile || uploadedFile.type !== 'pdf' || numPages <= 1) return null;

//     return (
//       <Box
//         sx={{
//           width: isMobile ? 80 : 100,
//           minWidth: isMobile ? 80 : 100,
//           borderLeft: '1px solid #e0e0e0',
//           bgcolor: '#fafafa',
//           overflowY: 'auto',
//           overflowX: 'hidden',
//           height: '100%',
//           display: 'flex',
//           flexDirection: 'column',
//           gap: 1,
//           p: 1,
//           // Fix scrollbar hiding issue
//           '::-webkit-scrollbar': {
//             width: '6px'
//           },
//           '::-webkit-scrollbar-track': {
//             background: '#f1f1f1',
//             borderRadius: '3px'
//           },
//           '::-webkit-scrollbar-thumb': {
//             background: '#c1c1c1',
//             borderRadius: '3px',
//             '&:hover': {
//               background: '#a8a8a8'
//             }
//           }
//         }}
//       >
//         <Typography
//           variant="caption"
//           sx={{
//             fontSize: isMobile ? '8px' : '10px',
//             fontWeight: 600,
//             textAlign: 'center',
//             color: '#666',
//             mb: 0.5
//           }}
//         >
//           Pages ({numPages})
//         </Typography>

//         {Array.from({ length: numPages }, (_, index) => {
//           const pageNum = index + 1;
//           const isCurrentPage = currentPage === pageNum;
//           const fieldsOnPage = signatureFields.filter(
//             (field) => field.pageNumber === pageNum
//           ).length;

//           return (
//             <Box
//               key={pageNum}
//               onClick={() => setCurrentPage(pageNum)}
//               sx={{
//                 position: 'relative',
//                 cursor: 'pointer',
//                 border: isCurrentPage ? '2px solid #1976d2' : '1px solid #ddd',
//                 borderRadius: 1,
//                 bgcolor: isCurrentPage ? '#e3f2fd' : 'white',
//                 overflow: 'hidden',
//                 transition: 'all 0.2s ease',
//                 '&:hover': {
//                   borderColor: '#1976d2',
//                   transform: 'scale(1.02)',
//                   boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
//                 },
//                 // Fixed dimensions for vertical page aspect ratio
//                 width: isMobile ? 60 : 80,
//                 height: isMobile ? 84 : 112, // 4:3 aspect ratio (more vertical/page-like)
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//                 mx: 'auto', // Center thumbnails
//                 flexShrink: 0
//               }}
//             >
//               <Document file={uploadedFile.preview} onLoadSuccess={() => {}}>
//                 <Page
//                   pageNumber={pageNum}
//                   width={isMobile ? 50 : 70}
//                   height={isMobile ? 70 : 98} // Maintain aspect ratio
//                   renderAnnotationLayer={false}
//                   renderTextLayer={false}
//                 />
//               </Document>

//               {/* Page number badge - positioned to not interfere with scrollbar */}
//               <Box
//                 sx={{
//                   position: 'absolute',
//                   bottom: 2,
//                   left: 2,
//                   bgcolor: isCurrentPage ? '#1976d2' : 'rgba(0,0,0,0.7)',
//                   color: 'white',
//                   px: 0.5,
//                   py: 0.25,
//                   borderRadius: 0.5,
//                   fontSize: isMobile ? '8px' : '10px',
//                   fontWeight: 600,
//                   lineHeight: 1,
//                   minWidth: 16,
//                   textAlign: 'center'
//                 }}
//               >
//                 {pageNum}
//               </Box>

//               {/* Fields count badge - positioned on top right */}
//               {fieldsOnPage > 0 && (
//                 <Box
//                   sx={{
//                     position: 'absolute',
//                     top: 2,
//                     right: 2,
//                     bgcolor: '#ff9800',
//                     color: 'white',
//                     minWidth: 16,
//                     height: 16,
//                     borderRadius: '50%',
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'center',
//                     fontSize: isMobile ? '8px' : '9px',
//                     fontWeight: 600,
//                     lineHeight: 1
//                   }}
//                 >
//                   {fieldsOnPage}
//                 </Box>
//               )}
//             </Box>
//           );
//         })}
//       </Box>
//     );
//   };

//   // File preview rendering
//   const renderFilePreview = () => {
//     if (!uploadedFile) {
//       return (
//         <Paper
//           elevation={1}
//           sx={{
//             height: isMobile ? 150 : 200,
//             width: '100%',
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//             bgcolor: '#f5f5f5',
//             borderRadius: 1
//           }}
//         >
//           <Typography variant="caption" color="text.secondary">
//             No document uploaded
//           </Typography>
//         </Paper>
//       );
//     }

//     const { file, preview, type } = uploadedFile;
//     const currentPageFields = signatureFields.filter((field) => field.pageNumber === currentPage);

//     if (type !== 'pdf') {
//       return (
//         <Fade in={!!uploadedFile}>
//           <Paper
//             elevation={2}
//             sx={{
//               p: 1,
//               mt: 1,
//               width: '100%',
//               display: 'flex',
//               flexDirection: 'column',
//               height: isMobile ? 'calc(100vh - 200px)' : 'calc(100vh - 160px)'
//             }}
//           >
//             {/* File info header */}
//             <Box sx={{ display: 'flex', alignItems: 'center', mb: 1, width: '100%' }}>
//               {getFileIcon(type || 'document')}
//               <Box sx={{ ml: 1, flex: 1, overflow: 'hidden' }}>
//                 <Typography
//                   variant="caption"
//                   sx={{
//                     fontSize: isMobile ? '10px' : '12px',
//                     fontWeight: 600
//                   }}
//                 >
//                   {file && file.name && file.name.length > 40
//                     ? `${file.name.substring(0, 40)}...`
//                     : file?.name || 'Unknown file'}
//                 </Typography>
//                 <Typography
//                   variant="caption"
//                   color="text.secondary"
//                   sx={{
//                     display: 'block',
//                     fontSize: isMobile ? '8px' : '10px'
//                   }}
//                 >
//                   {file?.size ? (file.size / 1024 / 1024).toFixed(2) : '0'} MB •{' '}
//                   {type?.toUpperCase() || 'UNKNOWN'}
//                 </Typography>
//               </Box>
//               <IconButton onClick={removeFile} color="error" size="small">
//                 <DeleteIcon sx={{ fontSize: 16 }} />
//               </IconButton>
//             </Box>

//             {/* Interactive container */}
//             <Box
//               sx={{
//                 flex: 1,
//                 overflow: 'auto',
//                 bgcolor: '#fafafa',
//                 border: `1px solid #e0e0e0`,
//                 borderRadius: 0.5,
//                 position: 'relative',
//                 userSelect: 'none',
//                 width: '100%'
//               }}
//               ref={pdfContainerRef}
//               onMouseMove={handleFieldMouseMove}
//               onMouseUp={handleFieldMouseUp}
//               onTouchMove={handleFieldTouchMove}
//               onTouchEnd={handleFieldMouseUp}
//             >
//               <Box
//                 sx={{
//                   position: 'relative',
//                   width: '100%',
//                   height: '100%',
//                   minHeight: '100%',
//                   cursor:
//                     selectedFieldType || selectedFieldTypes.length > 0
//                       ? 'crosshair'
//                       : isDraggingField
//                       ? 'grabbing'
//                       : 'default',
//                   background:
//                     selectedFieldType || selectedFieldTypes.length > 0
//                       ? 'repeating-linear-gradient(45deg,transparent,transparent 8px,rgba(0,0,255,0.05) 8px,rgba(0,0,255,0.05) 16px)'
//                       : 'transparent',
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'center'
//                 }}
//                 onClick={handlePageClick}
//               >
//                 {(selectedFieldType || selectedFieldTypes.length > 0) && (
//                   <Box
//                     sx={{
//                       position: 'absolute',
//                       top: 8,
//                       left: 8,
//                       bgcolor: 'primary.main',
//                       color: 'white',
//                       px: 1,
//                       py: 0.5,
//                       borderRadius: 0.5,
//                       zIndex: 10
//                     }}
//                   >
//                     <Typography variant="caption" sx={{ fontSize: '10px' }}>
//                       Click to place{' '}
//                       {selectedFieldType
//                         ? getFieldConfig(selectedFieldType)?.label
//                         : `${selectedFieldTypes.length} fields`}
//                     </Typography>
//                   </Box>
//                 )}

//                 {/* Image or document preview */}
//                 {type === 'image' ? (
//                   <img
//                     src={preview}
//                     alt="Preview"
//                     style={{
//                       maxWidth: '100%',
//                       maxHeight: '100%',
//                       width: 'auto',
//                       height: 'auto',
//                       display: 'block',
//                       objectFit: 'contain'
//                     }}
//                     onLoad={handlePageRenderSuccess} // **NEW: Trigger positioning after image loads**
//                   />
//                 ) : (
//                   <Box sx={{ textAlign: 'center', p: 2 }}>
//                     {getFileIcon(type || 'document')}
//                     <Typography variant="caption" sx={{ display: 'block', mt: 1 }}>
//                       Preview not available for this file type
//                     </Typography>
//                   </Box>
//                 )}

//                 {/* Render signature fields */}
//                 {signatureFields
//                   .filter((field) => field.pageNumber === 1)
//                   .map((field) => renderSignatureField(field))}
//               </Box>
//             </Box>
//           </Paper>
//         </Fade>
//       );
//     }

//     // PDF rendering with THUMBNAIL NAVIGATION on RIGHT side
//     return (
//       <Fade in={!!uploadedFile}>
//         <Paper
//           elevation={2}
//           sx={{
//             p: isMobile ? 0.5 : 1,
//             mt: isMobile ? 0.5 : 1,
//             position: 'relative',
//             width: '100%',
//             height: isMobile ? 'calc(100vh - 200px)' : 'calc(100vh - 160px)'
//           }}
//         >
//           {/* File info header */}
//           <Box
//             sx={{
//               display: 'flex',
//               alignItems: 'center',
//               mb: isMobile ? 0.5 : 1,
//               minHeight: isMobile ? 30 : 40
//             }}
//           >
//             <Box sx={{ display: 'flex', alignItems: 'center', flex: 1 }}>
//               {getFileIcon(type || 'pdf')}
//               <Box sx={{ ml: 1, overflow: 'hidden' }}>
//                 <Typography
//                   variant="caption"
//                   sx={{
//                     fontSize: isMobile ? '10px' : '12px',
//                     fontWeight: 600,
//                     display: 'block'
//                   }}
//                 >
//                   {file?.name && file.name.length > 40
//                     ? `${file.name.substring(0, 40)}...`
//                     : file?.name || 'Unknown file'}
//                 </Typography>
//                 <Typography
//                   variant="caption"
//                   color="text.secondary"
//                   sx={{ fontSize: isMobile ? '8px' : '10px' }}
//                 >
//                   {file?.size ? (file.size / 1024 / 1024).toFixed(2) : '0'} MB • Page {currentPage}/
//                   {numPages}
//                 </Typography>
//               </Box>
//             </Box>
//             <IconButton onClick={removeFile} color="error" size="small">
//               <DeleteIcon sx={{ fontSize: 16 }} />
//             </IconButton>
//           </Box>

//           {/* PDF controls */}
//           <Box
//             sx={{
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'space-between',
//               mb: isMobile ? 0.5 : 1,
//               minHeight: isMobile ? 30 : 35
//             }}
//           >
//             {/* Show page dropdown only on mobile for space */}
//             {isMobile && (
//               <FormControl size="small" sx={{ minWidth: 80 }}>
//                 <Select
//                   value={currentPage.toString()}
//                   onChange={(e) => setCurrentPage(Number(e.target.value))}
//                   sx={{ fontSize: '10px' }}
//                 >
//                   {Array.from({ length: numPages }, (_, i) => i + 1).map((pageNum) => (
//                     <MenuItem key={pageNum} value={pageNum} sx={{ fontSize: '10px' }}>
//                       P{pageNum}
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             )}

//             {!isMobile && (
//               <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                 <Typography variant="caption" sx={{ fontSize: '11px', color: '#666' }}>
//                   Page {currentPage} of {numPages}
//                 </Typography>
//               </Box>
//             )}

//             <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
//               <IconButton
//                 onClick={() => setScale(Math.max(0.5, scale - 0.1))}
//                 disabled={scale <= 0.5}
//                 size="small"
//               >
//                 <ZoomOutIcon sx={{ fontSize: isMobile ? 14 : 16 }} />
//               </IconButton>
//               <Typography
//                 variant="caption"
//                 sx={{ minWidth: '30px', textAlign: 'center', fontSize: isMobile ? '8px' : '10px' }}
//               >
//                 {Math.round(scale * 100)}%
//               </Typography>
//               <IconButton
//                 onClick={() => setScale(Math.min(2.0, scale + 0.1))}
//                 disabled={scale >= 2.0}
//                 size="small"
//               >
//                 <ZoomInIcon sx={{ fontSize: isMobile ? 14 : 16 }} />
//               </IconButton>
//               <IconButton onClick={toggleFullScreen} size="small">
//                 {fullScreenPdf ? (
//                   <FullscreenExitIcon sx={{ fontSize: isMobile ? 14 : 16 }} />
//                 ) : (
//                   <FullscreenIcon sx={{ fontSize: isMobile ? 14 : 16 }} />
//                 )}
//               </IconButton>
//             </Box>
//           </Box>

//           {/* MAIN CONTENT: PDF Viewer + Thumbnail Navigation (Thumbnails on RIGHT) */}
//           <Box
//             sx={{
//               border: `1px solid #e0e0e0`,
//               borderRadius: 0.5,
//               bgcolor: '#fafafa',
//               position: 'relative',
//               overflow: 'hidden',
//               height: 'calc(100% - 80px)',
//               width: '100%',
//               display: 'flex'
//             }}
//           >
//             {/* Right panel: Page thumbnails (only for desktop and multi-page PDFs) */}
//             {!isMobile && renderPageThumbnails()}
//             {/* Main PDF viewer - LEFT SIDE */}
//             <Box
//               sx={{
//                 flex: 1,
//                 position: 'relative',
//                 overflow: 'auto',
//                 userSelect: 'none'
//               }}
//               ref={pdfContainerRef}
//               onMouseMove={handleFieldMouseMove}
//               onMouseUp={handleFieldMouseUp}
//               onTouchMove={handleFieldTouchMove}
//               onTouchEnd={handleFieldMouseUp}
//             >
//               <Box
//                 sx={{
//                   position: 'relative',
//                   cursor:
//                     selectedFieldType || selectedFieldTypes.length > 0
//                       ? 'crosshair'
//                       : isDraggingField
//                       ? 'grabbing'
//                       : 'default',
//                   background:
//                     selectedFieldType || selectedFieldTypes.length > 0
//                       ? 'repeating-linear-gradient(45deg,transparent,transparent 8px,rgba(0,0,255,0.05) 8px,rgba(0,0,255,0.05) 16px)'
//                       : 'transparent',
//                   minHeight: '100%',
//                   width: '100%',
//                   display: 'flex',
//                   justifyContent: 'center',
//                   alignItems: 'flex-start',
//                   p: 1
//                 }}
//                 onClick={handlePageClick}
//               >
//                 {(selectedFieldType || selectedFieldTypes.length > 0) && (
//                   <Box
//                     sx={{
//                       position: 'absolute',
//                       top: 4,
//                       left: 4,
//                       bgcolor: 'primary.main',
//                       color: 'white',
//                       px: 1,
//                       py: 0.5,
//                       borderRadius: 0.5,
//                       zIndex: 10
//                     }}
//                   >
//                     <Typography variant="caption" sx={{ fontSize: isMobile ? '9px' : '11px' }}>
//                       Click to place{' '}
//                       {selectedFieldType
//                         ? getFieldConfig(selectedFieldType)?.label
//                         : `${selectedFieldTypes.length} fields`}
//                     </Typography>
//                   </Box>
//                 )}

//                 {/* **ENHANCED: PDF with render success callback** */}
//                 <Document
//                   file={preview}
//                   onLoadSuccess={onDocumentLoadSuccess}
//                   onLoadError={() => setPdfError('Failed to load PDF.')}
//                 >
//                   <Page
//                     pageNumber={currentPage}
//                     scale={scale}
//                     width={
//                       pdfContainerRef.current?.clientWidth
//                         ? pdfContainerRef.current.clientWidth - (isMobile ? 100 : 132) // Account for thumbnail width
//                         : undefined
//                     }
//                     renderTextLayer={false}
//                     onRenderSuccess={handlePageRenderSuccess} // **NEW: Critical fix**
//                   />
//                 </Document>
//                 {currentPageFields.map((field) => renderSignatureField(field))}
//               </Box>
//               {pdfError && (
//                 <Box
//                   sx={{
//                     position: 'absolute',
//                     top: 0,
//                     left: 0,
//                     right: 0,
//                     bottom: 0,
//                     bgcolor: 'rgba(0,0,0,0.5)',
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'center',
//                     color: 'white'
//                   }}
//                 >
//                   <Typography variant="caption">{pdfError}</Typography>
//                 </Box>
//               )}
//             </Box>
//           </Box>
//         </Paper>
//       </Fade>
//     );
//   };

//   const renderMobileFieldSelector = () => (
//     <Dialog
//       open={showMobileFieldSelector}
//       onClose={() => {
//         setShowMobileFieldSelector(false);
//         setMultiSelectMode(false);
//         setSelectedFieldTypes([]);
//       }}
//       fullScreen={isMobile}
//       maxWidth="sm"
//       fullWidth
//     >
//       <DialogTitle sx={{ pb: 1 }}>
//         <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
//           <Typography variant="subtitle2" sx={{ fontSize: '14px' }}>
//             Select Document Fields
//           </Typography>
//           <IconButton
//             size="small"
//             onClick={() => {
//               setShowMobileFieldSelector(false);
//               setMultiSelectMode(false);
//               setSelectedFieldTypes([]);
//             }}
//           >
//             <CloseIcon />
//           </IconButton>
//         </Box>
//       </DialogTitle>
//       <DialogContent sx={{ pb: 1 }}>{renderFieldTypeSelector()}</DialogContent>
//       <DialogActions>
//         <Button
//           onClick={() => {
//             setShowMobileFieldSelector(false);
//             setMultiSelectMode(false);
//             setSelectedFieldTypes([]);
//           }}
//           size="small"
//         >
//           Done
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );

//   const renderFieldTypeSelector = () => {
//     const fieldsByCategory = getFieldsByCategory();
//     const categoryNames = {
//       signature: 'Signatures',
//       personal: 'Personal',
//       contact: 'Contact',
//       dates: 'Dates',
//       other: 'Other'
//     };

//     return (
//       <Box sx={{ mb: 2 }}>
//         <Typography
//           variant="caption"
//           sx={{ fontWeight: 600, mb: 1, display: 'block', fontSize: isMobile ? '10px' : '11px' }}
//         >
//           Document Fields
//         </Typography>
//         <Typography
//           variant="caption"
//           color="text.secondary"
//           sx={{ mb: 1, display: 'block', fontSize: isMobile ? '8px' : '9px' }}
//         >
//           Click field type → Click {uploadedFile?.type === 'image' ? 'image' : 'PDF'} to place →
//           Drag to move → Toggle required → X to remove
//         </Typography>

//         {isMobile && (
//           <Box sx={{ mb: 1.5, display: 'flex', alignItems: 'center', gap: 1 }}>
//             <FormControlLabel
//               control={
//                 <Switch
//                   checked={multiSelectMode}
//                   onChange={(e) => {
//                     setMultiSelectMode(e.target.checked);
//                     if (!e.target.checked) {
//                       setSelectedFieldTypes([]);
//                     }
//                   }}
//                   size="small"
//                 />
//               }
//               label={
//                 <Typography variant="caption" sx={{ fontSize: '9px' }}>
//                   Multi-select
//                 </Typography>
//               }
//             />
//             {multiSelectMode && selectedFieldTypes.length > 0 && (
//               <Button size="small" variant="contained" sx={{ fontSize: '8px', py: 0.25 }}>
//                 Place {selectedFieldTypes.length} fields
//               </Button>
//             )}
//           </Box>
//         )}

//         <Stack spacing={1}>
//           {Object.entries(fieldsByCategory).map(([category, fields]) => (
//             <Box key={category}>
//               <Typography
//                 variant="caption"
//                 sx={{
//                   fontWeight: 600,
//                   mb: 0.5,
//                   display: 'block',
//                   fontSize: isMobile ? '9px' : '10px',
//                   opacity: 0.8
//                 }}
//               >
//                 {categoryNames[category as keyof typeof categoryNames] || category}
//               </Typography>
//               <Grid container spacing={0.5}>
//                 {(fields as any[]).map((fieldConfig) => {
//                   const isSelected = multiSelectMode
//                     ? selectedFieldTypes.includes(fieldConfig.fieldKey)
//                     : selectedFieldType === fieldConfig.fieldKey;

//                   return (
//                     <Grid item xs={6} key={fieldConfig.fieldKey}>
//                       <Tooltip title={fieldConfig.description} placement="top">
//                         <Button
//                           variant={isSelected ? 'contained' : 'outlined'}
//                           onClick={() => addSignatureField(fieldConfig.fieldKey)}
//                           sx={{
//                             width: '100%',
//                             minHeight: isMobile ? 28 : 32,
//                             textTransform: 'none',
//                             borderColor: fieldConfig.color,
//                             color: isSelected ? 'white' : fieldConfig.color,
//                             bgcolor: isSelected ? fieldConfig.color : 'transparent',
//                             '&:hover': {
//                               borderColor: fieldConfig.color,
//                               bgcolor: isSelected ? fieldConfig.color : `${fieldConfig.color}10`
//                             },
//                             fontSize: isMobile ? '8px' : '9px',
//                             display: 'flex',
//                             alignItems: 'center',
//                             gap: 0.25,
//                             p: 0.5,
//                             position: 'relative'
//                           }}
//                         >
//                           <Box sx={{ fontSize: isMobile ? '10px' : '12px' }}>
//                             {React.cloneElement(fieldConfig.icon as React.ReactElement, {
//                               fontSize: 'inherit'
//                             })}
//                           </Box>
//                           <span>{fieldConfig.label}</span>
//                           {fieldConfig.defaultRequired && (
//                             <StarIcon
//                               sx={{
//                                 position: 'absolute',
//                                 top: -2,
//                                 right: -2,
//                                 color: '#f44336',
//                                 fontSize: '8px'
//                               }}
//                             />
//                           )}
//                         </Button>
//                       </Tooltip>
//                     </Grid>
//                   );
//                 })}
//               </Grid>
//             </Box>
//           ))}
//         </Stack>

//         {(selectedFieldType || selectedFieldTypes.length > 0) && (
//           <Alert
//             severity="info"
//             sx={{
//               mt: 1,
//               '& .MuiAlert-message': {
//                 fontSize: isMobile ? '8px' : '10px'
//               }
//             }}
//           >
//             {multiSelectMode && selectedFieldTypes.length > 0 ? (
//               <>
//                 Selected: <strong>{selectedFieldTypes.length} fields</strong>
//               </>
//             ) : (
//               <>
//                 Selected: <strong>{getFieldConfig(selectedFieldType!).label}</strong>
//               </>
//             )}
//           </Alert>
//         )}

//         {signatureFields.length > 0 && (
//           <Box sx={{ mt: 1.5 }}>
//             <Typography
//               variant="caption"
//               sx={{ mb: 0.5, display: 'block', fontSize: isMobile ? '9px' : '10px' }}
//             >
//               Placed ({signatureFields.length}) - Required:{' '}
//               {Object.values(fieldRequirements).filter(Boolean).length}
//             </Typography>
//             <Box sx={{ maxHeight: isMobile ? 80 : 100, overflow: 'auto' }}>
//               <Stack spacing={0.25}>
//                 {signatureFields.map((field) => {
//                   const config =
//                     fieldTypes.find((f: any) => f.label === field.fieldLabel) || fieldTypes[0];
//                   const isRequired = fieldRequirements[field.id] || false;
//                   return (
//                     <Box
//                       key={field.id}
//                       sx={{
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'space-between',
//                         bgcolor: '#f5f5f5',
//                         p: 0.25,
//                         borderRadius: 0.5,
//                         border: `1px solid ${config.color}15`
//                       }}
//                     >
//                       <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.25, flex: 1 }}>
//                         <Box sx={{ fontSize: '8px', color: config.color }}>
//                           {React.cloneElement(config.icon as React.ReactElement, {
//                             fontSize: 'inherit'
//                           })}
//                         </Box>
//                         <Typography variant="caption" sx={{ fontSize: isMobile ? '7px' : '8px' }}>
//                           P{field.pageNumber}: {config.label}
//                           {isRequired && (
//                             <StarIcon sx={{ fontSize: '8px', color: '#f44336', ml: 0.25 }} />
//                           )}
//                         </Typography>
//                       </Box>
//                       <Box sx={{ display: 'flex', gap: 0.25 }}>
//                         <FormControlLabel
//                           control={
//                             <Switch
//                               checked={isRequired}
//                               onChange={() => toggleFieldRequirement(field.id)}
//                               size="small"
//                               sx={{
//                                 padding: 0,
//                                 '& .MuiSwitch-switchBase': {
//                                   padding: 3,
//                                   '&.Mui-checked': {
//                                     transform: 'translateX(8px)',
//                                     color: '#fff',
//                                     '& + .MuiSwitch-track': {
//                                       backgroundColor: '#f44336',
//                                       opacity: 1
//                                     }
//                                   }
//                                 },
//                                 '& .MuiSwitch-thumb': {
//                                   width: 10,
//                                   height: 10,
//                                   boxShadow: 'none'
//                                 },
//                                 '& .MuiSwitch-track': {
//                                   borderRadius: 12,
//                                   height: 14,
//                                   width: 28,
//                                   opacity: 1,
//                                   backgroundColor: '#ccc'
//                                 }
//                               }}
//                             />
//                           }
//                           label=""
//                           sx={{ m: 0 }}
//                           title={isRequired ? 'Required' : 'Optional'}
//                         />
//                         <IconButton
//                           size="small"
//                           color="error"
//                           onClick={() => removeSignatureField(field.id)}
//                           sx={{ p: 0.25 }}
//                         >
//                           <DeleteIcon sx={{ fontSize: '8px' }} />
//                         </IconButton>
//                       </Box>
//                     </Box>
//                   );
//                 })}
//               </Stack>
//             </Box>
//           </Box>
//         )}
//       </Box>
//     );
//   };

//   // Enhanced fullscreen PDF viewer with thumbnails on right
//   const renderFullScreenPdfViewer = () => {
//     if (!uploadedFile || uploadedFile.type !== 'pdf') return null;
//     const currentPageFields = signatureFields.filter((field) => field.pageNumber === currentPage);

//     const THUMBNAIL_WIDTH = 100; // Fixed width for thumbnail panel
//     const HEADER_PADDING = 16; // Header padding
//     const BORDER_WIDTH = 2; // Border width consideration

//     return (
//       <Box
//         sx={{
//           position: 'fixed',
//           top: 0,
//           left: 0,
//           width: '88vw',
//           // height: '100dvh',
//           bgcolor: 'white',
//           zIndex: 1300,
//           p: 1,
//           display: 'flex',
//           flexDirection: 'column'
//         }}
//       >
//         {/* Header Controls */}
//         <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
//           <Typography variant="subtitle2" sx={{ fontSize: isMobile ? '12px' : '14px' }}>
//             {uploadedFile.file?.name || 'Document'}
//           </Typography>
//           <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
//             <Typography variant="caption" sx={{ fontSize: '11px', mr: 2 }}>
//               Page {currentPage} of {numPages}
//             </Typography>
//             <IconButton
//               onClick={() => setScale(Math.max(0.5, scale - 0.1))}
//               disabled={scale <= 0.5}
//               size="small"
//             >
//               <ZoomOutIcon sx={{ fontSize: 16 }} />
//             </IconButton>
//             <Typography
//               variant="caption"
//               sx={{
//                 minWidth: '30px',
//                 textAlign: 'center',
//                 fontSize: '9px'
//               }}
//             >
//               {Math.round(scale * 100)}%
//             </Typography>
//             <IconButton
//               onClick={() => setScale(Math.min(2.0, scale + 0.1))}
//               disabled={scale >= 2.0}
//               size="small"
//             >
//               <ZoomInIcon sx={{ fontSize: 16 }} />
//             </IconButton>
//             <IconButton onClick={toggleFullScreen} size="small">
//               <FullscreenExitIcon sx={{ fontSize: 16 }} />
//             </IconButton>
//           </Box>
//         </Box>

//         {/* Main Content Area - Fullscreen with thumbnail navigation on RIGHT */}
//         <Box
//           sx={{
//             flex: 1,
//             overflow: 'hidden',
//             bgcolor: '#fafafa',
//             border: `1px solid #e0e0e0`,
//             borderRadius: 0.5,
//             position: 'relative',
//             display: 'flex'
//           }}
//         >
//           {/* Main PDF viewer - LEFT SIDE (takes remaining space) */}
//           <Box
//             sx={{
//               flex: 1,
//               overflow: 'auto',
//               position: 'relative',
//               userSelect: 'none'
//             }}
//             ref={pdfContainerRef}
//             onMouseMove={handleFieldMouseMove}
//             onMouseUp={handleFieldMouseUp}
//             onTouchMove={handleFieldTouchMove}
//             onTouchEnd={handleFieldMouseUp}
//           >
//             <Box
//               sx={{
//                 position: 'relative',
//                 cursor:
//                   selectedFieldType || selectedFieldTypes.length > 0
//                     ? 'crosshair'
//                     : isDraggingField
//                     ? 'grabbing'
//                     : 'default',
//                 background:
//                   selectedFieldType || selectedFieldTypes.length > 0
//                     ? 'repeating-linear-gradient(45deg,transparent,transparent 8px,rgba(33,115,70,0.05) 8px,rgba(33,115,70,0.05) 16px)'
//                     : 'transparent',
//                 minHeight: '100%',
//                 display: 'flex',
//                 justifyContent: 'center',
//                 alignItems: 'flex-start',
//                 p: 1
//               }}
//               onClick={handlePageClick}
//             >
//               {(selectedFieldType || selectedFieldTypes.length > 0) && (
//                 <Box
//                   sx={{
//                     position: 'absolute',
//                     top: 8,
//                     left: 8,
//                     bgcolor: '#217346',
//                     color: 'white',
//                     px: 1,
//                     py: 0.5,
//                     borderRadius: 0.5,
//                     zIndex: 10
//                   }}
//                 >
//                   <Typography variant="caption" sx={{ fontSize: '10px' }}>
//                     Click to place{' '}
//                     {selectedFieldType
//                       ? getFieldConfig(selectedFieldType)?.label
//                       : `${selectedFieldTypes.length} fields`}
//                   </Typography>
//                 </Box>
//               )}

//               {/* PDF Document with calculated width to fit container */}
//               <Document
//                 file={uploadedFile.preview}
//                 onLoadSuccess={onDocumentLoadSuccess}
//                 onLoadError={() => setPdfError('Failed to load PDF in full screen.')}
//               >
//                 <Page
//                   pageNumber={currentPage}
//                   scale={scale}
//                   width={
//                     pdfContainerRef.current?.clientWidth
//                       ? pdfContainerRef.current.clientWidth - 20 // Account for container padding
//                       : window.innerWidth - THUMBNAIL_WIDTH - HEADER_PADDING - BORDER_WIDTH
//                   }
//                   renderTextLayer={false}
//                 />
//               </Document>
//               {currentPageFields.map((field) => renderSignatureField(field))}
//             </Box>
//           </Box>

//           {/* Thumbnail Panel - RIGHT SIDE (fixed width) */}
//           <Box
//             sx={{
//               width: THUMBNAIL_WIDTH,
//               minWidth: THUMBNAIL_WIDTH,
//               borderLeft: '1px solid #e0e0e0',
//               bgcolor: '#fafafa',
//               overflowY: 'auto',
//               overflowX: 'hidden',
//               height: '100%',
//               display: 'flex',
//               flexDirection: 'column',
//               gap: 1,
//               p: 1,
//               // Fix scrollbar styling
//               '::-webkit-scrollbar': {
//                 width: '6px'
//               },
//               '::-webkit-scrollbar-track': {
//                 background: '#f1f1f1',
//                 borderRadius: '3px'
//               },
//               '::-webkit-scrollbar-thumb': {
//                 background: '#c1c1c1',
//                 borderRadius: '3px',
//                 '&:hover': {
//                   background: '#a8a8a8'
//                 }
//               }
//             }}
//           >
//             <Typography
//               variant="caption"
//               sx={{
//                 fontSize: isMobile ? '8px' : '10px',
//                 fontWeight: 600,
//                 textAlign: 'center',
//                 color: '#666',
//                 mb: 0.5
//               }}
//             >
//               Pages ({numPages})
//             </Typography>

//             {Array.from({ length: numPages }, (_, index) => {
//               const pageNum = index + 1;
//               const isCurrentPage = currentPage === pageNum;
//               const fieldsOnPage = signatureFields.filter(
//                 (field) => field.pageNumber === pageNum
//               ).length;

//               return (
//                 <Box
//                   key={pageNum}
//                   onClick={() => setCurrentPage(pageNum)}
//                   sx={{
//                     position: 'relative',
//                     cursor: 'pointer',
//                     border: isCurrentPage ? '2px solid #217346' : '1px solid #ddd',
//                     borderRadius: 1,
//                     bgcolor: isCurrentPage ? '#e8f5e9' : 'white',
//                     overflow: 'hidden',
//                     transition: 'all 0.2s ease',
//                     '&:hover': {
//                       borderColor: '#217346',
//                       transform: 'scale(1.02)',
//                       boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
//                     },
//                     width: isMobile ? 60 : 80,
//                     height: isMobile ? 84 : 112,
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'center',
//                     mx: 'auto',
//                     flexShrink: 0
//                   }}
//                 >
//                   <Document file={uploadedFile.preview} onLoadSuccess={() => {}}>
//                     <Page
//                       pageNumber={pageNum}
//                       width={isMobile ? 50 : 70}
//                       height={isMobile ? 70 : 98}
//                       renderAnnotationLayer={false}
//                       renderTextLayer={false}
//                     />
//                   </Document>

//                   {/* Page number badge */}
//                   <Box
//                     sx={{
//                       position: 'absolute',
//                       bottom: 2,
//                       left: 2,
//                       bgcolor: isCurrentPage ? '#217346' : 'rgba(0,0,0,0.7)',
//                       color: 'white',
//                       px: 0.5,
//                       py: 0.25,
//                       borderRadius: 0.5,
//                       fontSize: isMobile ? '8px' : '10px',
//                       fontWeight: 600,
//                       lineHeight: 1,
//                       minWidth: 16,
//                       textAlign: 'center'
//                     }}
//                   >
//                     {pageNum}
//                   </Box>

//                   {/* Fields count badge */}
//                   {fieldsOnPage > 0 && (
//                     <Box
//                       sx={{
//                         position: 'absolute',
//                         top: 2,
//                         right: 2,
//                         bgcolor: '#217346',
//                         color: 'white',
//                         minWidth: 16,
//                         height: 16,
//                         borderRadius: '50%',
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'center',
//                         fontSize: isMobile ? '8px' : '9px',
//                         fontWeight: 600,
//                         lineHeight: 1
//                       }}
//                     >
//                       {fieldsOnPage}
//                     </Box>
//                   )}
//                 </Box>
//               );
//             })}
//           </Box>
//         </Box>
//       </Box>
//     );
//   };

//   return (
//     <Box>
//       {/* Mobile Field Selector FAB */}
//       {isMobile && activeTab === 0 && (
//         <Fab
//           color="primary"
//           size="medium"
//           sx={{
//             position: 'fixed',
//             bottom: 80,
//             right: 16,
//             zIndex: 1000,
//             bgcolor: '#217346',
//             '&:hover': { bgcolor: '#1a5d37' }
//           }}
//           onClick={() => setShowMobileFieldSelector(true)}
//         >
//           <SettingsIcon />
//         </Fab>
//       )}

//       <Typography
//         variant="caption"
//         sx={{
//           mb: 1,
//           color: '#333',
//           fontSize: isMobile ? '11px' : '13px',
//           fontWeight: 600,
//           display: 'block'
//         }}
//       >
//         Step 2: Define Document Fields
//       </Typography>

//       {!uploadedFile ? (
//         <Box sx={{ textAlign: 'center', py: 4 }}>
//           <UploadIcon sx={{ fontSize: 48, color: '#ccc', mb: 2 }} />
//           <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
//             Please upload a document first
//           </Typography>
//           <Button
//             variant="contained"
//             component="label"
//             startIcon={<UploadIcon />}
//             sx={{ backgroundColor: '#217346', '&:hover': { backgroundColor: '#1a5d37' } }}
//           >
//             Browse Files
//             <input
//               ref={fileInputRef}
//               type="file"
//               accept=".pdf,.doc,.docx,.jpg,.jpeg,.png,.gif,.webp"
//               hidden
//               onChange={handleUpload}
//             />
//           </Button>
//         </Box>
//       ) : (
//         <>
//           {fullScreenPdf ? (
//             renderFullScreenPdfViewer()
//           ) : (
//             <>
//               {isMobile ? (
//                 <Box>
//                   <Tabs
//                     value={activeTab}
//                     onChange={(e, newValue) => setActiveTab(newValue)}
//                     variant="fullWidth"
//                     sx={{ mb: 1 }}
//                   >
//                     <Tab label="Preview" sx={{ fontSize: '10px', minHeight: 36 }} />
//                     <Tab label="Fields" sx={{ fontSize: '10px', minHeight: 36 }} />
//                   </Tabs>
//                   {activeTab === 0 ? renderFilePreview() : <Box>{renderFieldTypeSelector()}</Box>}
//                 </Box>
//               ) : (
//                 <Grid container spacing={1}>
//                   <Grid item xs={12} md={9}>
//                     {renderFilePreview()}
//                   </Grid>
//                   <Grid item xs={12} md={3}>
//                     <Card elevation={1} sx={{ height: 'calc(100vh - 180px)', overflow: 'auto' }}>
//                       <CardContent sx={{ p: 1 }}>{renderFieldTypeSelector()}</CardContent>
//                     </Card>
//                   </Grid>
//                 </Grid>
//               )}
//             </>
//           )}
//         </>
//       )}

//       {/* Mobile Field Selector Dialog */}
//       {renderMobileFieldSelector()}

//       {/* Confirmation Dialog */}
//       <ConfirmationDialog
//         open={showConfirmation}
//         title="No Fields Added"
//         message="You haven't added any signature fields to the document. Do you want to proceed without adding fields?"
//         confirmButtonText="Proceed Anyway"
//         confirmButtonColor="secondary"
//         onConfirm={() => {
//           setShowConfirmation(false);
//           onNext();
//         }}
//         onCancel={() => setShowConfirmation(false)}
//         loading={false}
//       />

//       {/* Navigation */}
//       <Box
//         sx={{
//           mt: 2,
//           display: 'flex',
//           justifyContent: 'flex-end', // push to right side
//           gap: 1, // add spacing between buttons
//           alignItems: 'center'
//         }}
//       >
//         <Button
//           onClick={onBack}
//           sx={{ color: '#666', fontSize: isMobile ? '10px' : '12px' }}
//           startIcon={<IoArrowBackCircleOutline size={isMobile ? 12 : 14} />}
//           size="small"
//         >
//           Back
//         </Button>

//         <Button
//           variant="contained"
//           onClick={() => {
//             if (uploadedFile && signatureFields.length === 0) {
//               setShowConfirmation(true);
//             } else {
//               onNext();
//             }
//           }}
//           disabled={!uploadedFile}
//           sx={{
//             minWidth: isMobile ? 80 : 100,
//             fontSize: isMobile ? '10px' : '12px',
//             backgroundColor: '#217346',
//             '&:hover': { backgroundColor: '#1a5d37' }
//           }}
//           size="small"
//         >
//           Next
//         </Button>
//       </Box>
//     </Box>
//   );
// };

// export default DocumentEditingStep;
import React, { useState, useEffect, useCallback, useRef } from 'react';
import {
  Box,
  Button,
  Grid,
  IconButton,
  Typography,
  useTheme,
  useMediaQuery,
  Tabs,
  Tab,
  Tooltip,
  Card,
  CardContent,
  Fab,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Switch,
  FormControlLabel,
  Alert,
  Stack,
  Paper,
  Fade,
  FormControl,
  Select,
  MenuItem
} from '@mui/material';
import {
  CloudUpload as UploadIcon,
  PictureAsPdf as PdfIcon,
  Image as ImageIcon,
  Description as DocumentIcon,
  Delete as DeleteIcon,
  Fullscreen as FullscreenIcon,
  FullscreenExit as FullscreenExitIcon,
  ZoomOut as ZoomOutIcon,
  ZoomIn as ZoomInIcon,
  Close as CloseIcon,
  DragIndicator as DragIcon,
  Settings as SettingsIcon,
  Star as StarIcon,
  GridOn as GridIcon
} from '@mui/icons-material';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
import fieldTypes from '../SignatureFields';
import { SignatureField, UploadedFile } from '../types';
import { IoArrowBackCircleOutline } from 'react-icons/io5';
import ConfirmationDialog from 'commonComponents/ConfirmationDialog';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

interface DocumentEditingStepProps {
  uploadedFile: UploadedFile | null;
  setUploadedFile: (file: UploadedFile | null) => void;
  signatureFields: SignatureField[];
  setSignatureFields: (
    fields: SignatureField[] | ((prev: SignatureField[]) => SignatureField[])
  ) => void;
  fieldRequirements: Record<string, boolean>;
  setFieldRequirements: (
    requirements:
      | Record<string, boolean>
      | ((prev: Record<string, boolean>) => Record<string, boolean>)
  ) => void;
  setSuccessMessage: (message: string | null) => void;
  onBack: () => void;
  onNext: () => void;
}

const DocumentEditingStep: React.FC<DocumentEditingStepProps> = ({
  uploadedFile,
  setUploadedFile,
  signatureFields,
  setSignatureFields,
  fieldRequirements,
  setFieldRequirements,
  setSuccessMessage,
  onBack,
  onNext
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  // Local state for document editing
  const [selectedFieldType, setSelectedFieldType] = useState<string | null>(null);
  const [multiSelectMode, setMultiSelectMode] = useState(false);
  const [selectedFieldTypes, setSelectedFieldTypes] = useState<string[]>([]);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [showMobileFieldSelector, setShowMobileFieldSelector] = useState(false);
  const [fullScreenPdf, setFullScreenPdf] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [numPages, setNumPages] = useState<number>(0);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [scale, setScale] = useState<number>(1.0);
  const [pdfError, setPdfError] = useState<string | null>(null);

  // PDF render trigger state
  const [pdfRenderTrigger, setPdfRenderTrigger] = useState(0);
  const [isDocumentReady, setIsDocumentReady] = useState(true);

  // Drag states
  const [draggingFieldId, setDraggingFieldId] = useState<string | null>(null);
  const [dragOffset, setDragOffset] = useState<{ x: number; y: number } | null>(null);
  const [isDraggingField, setIsDraggingField] = useState(false);
  const [initialScrollPos, setInitialScrollPos] = useState<{ x: number; y: number } | null>(null);

  const fileInputRef = useRef<HTMLInputElement>(null);
  const pdfContainerRef = useRef<HTMLDivElement>(null);
  const documentRenderTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  // Window resize handler to trigger field repositioning
  useEffect(() => {
    const handleResize = () => {
      if (documentRenderTimeoutRef.current) {
        clearTimeout(documentRenderTimeoutRef.current);
      }
      documentRenderTimeoutRef.current = setTimeout(() => {
        setPdfRenderTrigger((prev) => prev + 1);
      }, 100);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
      if (documentRenderTimeoutRef.current) {
        clearTimeout(documentRenderTimeoutRef.current);
      }
    };
  }, []);

  // Effect to trigger field repositioning when document is ready
  useEffect(() => {
    if (signatureFields.length > 0 && isDocumentReady) {
      const timer = setTimeout(() => {
        setPdfRenderTrigger((prev) => prev + 1);
      }, 200);
      return () => clearTimeout(timer);
    }
  }, [signatureFields.length, isDocumentReady]);

  // Helper functions
  const getFieldConfig = (fieldKey: string) =>
    fieldTypes.find((f) => f.fieldKey === fieldKey) || fieldTypes[0];

  const getFieldsByCategory = () => {
    const grouped = fieldTypes.reduce((acc, field) => {
      if (!acc[field.category]) acc[field.category] = [];
      acc[field.category].push(field);
      return acc;
    }, {} as Record<string, typeof fieldTypes>);
    return grouped;
  };

  const fileToBase64 = (file: File): Promise<string> =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(file);
    });

  const getFileType = (file: File): 'pdf' | 'image' | 'document' => {
    if (file.type === 'application/pdf') return 'pdf';
    if (file.type.startsWith('image/')) return 'image';
    if (
      file.type === 'application/msword' ||
      file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    ) {
      return 'document';
    }
    return 'document';
  };

  const getFileExtension = (filename: string): string => {
    return filename.split('.').pop()?.toLowerCase() || '';
  };

  const getFileIcon = (type: 'pdf' | 'image' | 'document') => {
    const iconSize = isMobile ? 16 : 20;
    switch (type) {
      case 'pdf':
        return <PdfIcon sx={{ fontSize: iconSize, color: '#f44336' }} />;
      case 'image':
        return <ImageIcon sx={{ fontSize: iconSize, color: '#2196f3' }} />;
      case 'document':
        return <DocumentIcon sx={{ fontSize: iconSize, color: '#4caf50' }} />;
      default:
        return <DocumentIcon sx={{ fontSize: iconSize, color: '#9e9e9e' }} />;
    }
  };

  const simulateUpload = (file: File): Promise<void> =>
    new Promise((resolve) => {
      let progress = 0;
      const interval = setInterval(() => {
        progress += Math.random() * 20;
        if (progress >= 100) {
          clearInterval(interval);
          setTimeout(() => {
            setSuccessMessage('File uploaded successfully!');
            resolve();
          }, 500);
        }
      }, 200);
    });

  const processFile = async (file: File) => {
    const allowedMimeTypes = [
      'application/pdf',
      'image/jpeg',
      'image/jpg',
      'image/png',
      'image/gif',
      'image/webp',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    ];

    const allowedExtensions = ['pdf', 'doc', 'docx', 'png', 'jpg', 'jpeg', 'gif', 'webp'];
    const fileExtension = getFileExtension(file.name);

    if (!allowedMimeTypes.includes(file.type) && !allowedExtensions.includes(fileExtension)) {
      setPdfError(
        'Unsupported file type. Supported types: pdf, docx, doc, png, jpg, jpeg, gif, webp'
      );
      return;
    }

    if (file.size > 10 * 1024 * 1024) {
      setPdfError('File size must be less than 10MB');
      return;
    }

    try {
      await simulateUpload(file);
      const fileType = getFileType(file);
      const preview = URL.createObjectURL(file);
      const base64 = await fileToBase64(file);
      setUploadedFile({ file, preview, type: fileType, base64 });
      setIsDocumentReady(false);
      setPdfError(null);
    } catch (error) {
      setPdfError('Failed to process file');
    }
  };

  const handleUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files?.length) {
      await processFile(e.target.files[0]);
      if (fileInputRef.current) fileInputRef.current.value = '';
    }
  };

  const removeFile = () => {
    if (uploadedFile?.preview) URL.revokeObjectURL(uploadedFile.preview);
    setUploadedFile(null);
    setSignatureFields([]);
    setIsDocumentReady(true);
    setPdfError(null);
    if (fileInputRef.current) fileInputRef.current.value = '';
  };

  // Document load success with proper initialization
  const onDocumentLoadSuccess = ({ numPages }: { numPages: number }) => {
    console.log('Document loaded successfully, pages:', numPages);
    setNumPages(numPages);
    setIsDocumentReady(false);
  };

  // Page render success handler
  const handlePageRenderSuccess = useCallback(() => {
    console.log('Page rendered successfully');
    setIsDocumentReady(true);
    setPdfRenderTrigger((prev) => prev + 1);
  }, []);

  // Handle click with direct field placement (no tags)
  const handlePageClick = useCallback(
    (event: React.MouseEvent<HTMLDivElement>) => {
      if (
        (!selectedFieldType && selectedFieldTypes.length === 0) ||
        !pdfContainerRef.current ||
        draggingFieldId
      )
        return;

      const rect = pdfContainerRef.current.getBoundingClientRect();
      const scrollTop = pdfContainerRef.current.scrollTop;
      const scrollLeft = pdfContainerRef.current.scrollLeft;

      // Get container dimensions properly for both cases
      let docWidth: number, docHeight: number;

      if (uploadedFile) {
        const docElement = pdfContainerRef.current.querySelector('canvas, img');
        if (!docElement) return;
        docWidth = docElement.clientWidth;
        docHeight = docElement.clientHeight;
      } else {
        const clickArea = pdfContainerRef.current.querySelector(
          '[data-click-area="true"]'
        ) as HTMLElement;
        if (clickArea) {
          docWidth = clickArea.clientWidth;
          docHeight = clickArea.clientHeight;
        } else {
          docWidth = pdfContainerRef.current.clientWidth;
          docHeight = Math.max(pdfContainerRef.current.clientHeight, 600);
        }
      }

      // Calculate click position relative to document/container
      const x = event.clientX - rect.left + scrollLeft;
      const y = event.clientY - rect.top + scrollTop;

      // Calculate percentage positions
      const xPercent = (x / docWidth) * 100;
      const yPercent = (y / docHeight) * 100;

      const getDefaultDimensions = (fieldKey: string) => {
        switch (fieldKey) {
          case 'signature':
            return { width: isMobile ? 120 : 140, height: isMobile ? 35 : 40 };
          case 'initials':
            return { width: isMobile ? 60 : 80, height: isMobile ? 25 : 30 };
          case 'checkbox':
            return { width: 16, height: 16 };
          case 'address':
            return { width: isMobile ? 140 : 160, height: isMobile ? 50 : 60 };
          case 'date':
          case 'expiry':
            return { width: isMobile ? 80 : 100, height: isMobile ? 20 : 25 };
          default:
            return { width: isMobile ? 80 : 100, height: isMobile ? 20 : 25 };
        }
      };

      const pageNumber = uploadedFile?.type === 'image' || !uploadedFile ? 1 : currentPage;

      // Direct field placement
      if (selectedFieldTypes.length > 0) {
        // Handle multi-select mode
        const newFields: SignatureField[] = [];
        selectedFieldTypes.forEach((fieldKey, index) => {
          const dimensions = getDefaultDimensions(fieldKey);
          const config = getFieldConfig(fieldKey);
          const fieldId = `${fieldKey}-${Date.now()}-${Math.random()}-${index}`;
          const fieldXPercent = xPercent + index * 2;
          const fieldYPercent = yPercent + index * 1;

          const newField: SignatureField = {
            id: fieldId,
            type: config.type,
            x: (fieldXPercent / 100) * docWidth,
            y: (fieldYPercent / 100) * docHeight,
            pageNumber: pageNumber,
            value: '',
            width: dimensions.width,
            height: dimensions.height,
            isRequired: config.defaultRequired,
            fieldLabel: config.label,
            xPercent: fieldXPercent,
            yPercent: fieldYPercent,
            widthPercent: (dimensions.width / docWidth) * 100,
            heightPercent: (dimensions.height / docHeight) * 100
          };
          newFields.push(newField);
          setFieldRequirements((prev) => ({
            ...prev,
            [fieldId]: config.defaultRequired
          }));
        });
        setSignatureFields([...signatureFields, ...newFields]);
        setSelectedFieldTypes([]);
        setMultiSelectMode(false);
        if (isMobile) setShowMobileFieldSelector(false);
      } else if (selectedFieldType) {
        // Handle single field placement
        const dimensions = getDefaultDimensions(selectedFieldType);
        const config = getFieldConfig(selectedFieldType);
        const fieldId = `${selectedFieldType}-${Date.now()}-${Math.random()}`;

        const newField: SignatureField = {
          id: fieldId,
          type: config.type,
          x: (xPercent / 100) * docWidth,
          y: (yPercent / 100) * docHeight,
          pageNumber: pageNumber,
          value: '',
          width: dimensions.width,
          height: dimensions.height,
          isRequired: config.defaultRequired,
          fieldLabel: config.label,
          xPercent: xPercent,
          yPercent: yPercent,
          widthPercent: (dimensions.width / docWidth) * 100,
          heightPercent: (dimensions.height / docHeight) * 100
        };
        setSignatureFields([...signatureFields, newField]);
        setFieldRequirements((prev) => ({
          ...prev,
          [fieldId]: config.defaultRequired
        }));
        setSelectedFieldType(null);
      }
    },
    [
      selectedFieldType,
      selectedFieldTypes,
      currentPage,
      signatureFields,
      draggingFieldId,
      isMobile,
      uploadedFile?.type,
      setSignatureFields,
      setFieldRequirements
    ]
  );

  const addSignatureField = (fieldKey: string) => {
    if (multiSelectMode) {
      setSelectedFieldTypes((prev) =>
        prev.includes(fieldKey) ? prev.filter((t) => t !== fieldKey) : [...prev, fieldKey]
      );
    } else {
      setSelectedFieldType(fieldKey);
      setDraggingFieldId(null);
      setIsDraggingField(false);
      if (isMobile) setShowMobileFieldSelector(false);
    }
  };

  // Enhanced drag functionality
  const handleFieldMouseDown = (fieldId: string, event: React.MouseEvent<HTMLDivElement>) => {
    if (selectedFieldType || selectedFieldTypes.length > 0) return;
    event.stopPropagation();
    event.preventDefault();

    setDraggingFieldId(fieldId);
    setIsDraggingField(true);

    const field = signatureFields.find((f) => f.id === fieldId);
    if (field && pdfContainerRef.current) {
      const rect = pdfContainerRef.current.getBoundingClientRect();
      const scrollTop = pdfContainerRef.current.scrollTop;
      const scrollLeft = pdfContainerRef.current.scrollLeft;

      setInitialScrollPos({ x: scrollLeft, y: scrollTop });

      // Use percentage-based positioning for consistency
      let docWidth: number, docHeight: number;

      if (uploadedFile) {
        const docElement = pdfContainerRef.current.querySelector('canvas, img');
        if (docElement) {
          docWidth = docElement.clientWidth;
          docHeight = docElement.clientHeight;
        } else {
          docWidth = pdfContainerRef.current.clientWidth;
          docHeight = pdfContainerRef.current.clientHeight;
        }
      } else {
        const clickArea = pdfContainerRef.current.querySelector(
          '[data-click-area="true"]'
        ) as HTMLElement;
        if (clickArea) {
          docWidth = clickArea.clientWidth;
          docHeight = clickArea.clientHeight;
        } else {
          docWidth = pdfContainerRef.current.clientWidth;
          docHeight = Math.max(pdfContainerRef.current.clientHeight, 600);
        }
      }

      // Calculate current field position from percentage
      const fieldX = (field.xPercent / 100) * docWidth;
      const fieldY = (field.yPercent / 100) * docHeight;

      setDragOffset({
        x: event.clientX - rect.left - fieldX + scrollLeft,
        y: event.clientY - rect.top - fieldY + scrollTop
      });
    }
  };

  // Touch event handler for mobile devices
  const handleFieldTouchStart = (fieldId: string, event: React.TouchEvent<HTMLDivElement>) => {
    if (selectedFieldType || selectedFieldTypes.length > 0) return;
    event.stopPropagation();
    event.preventDefault();

    const touch = event.touches[0];
    setDraggingFieldId(fieldId);
    setIsDraggingField(true);

    const field = signatureFields.find((f) => f.id === fieldId);
    if (field && pdfContainerRef.current) {
      const rect = pdfContainerRef.current.getBoundingClientRect();
      const scrollTop = pdfContainerRef.current.scrollTop;
      const scrollLeft = pdfContainerRef.current.scrollLeft;

      setInitialScrollPos({ x: scrollLeft, y: scrollTop });

      // Use percentage-based positioning for consistency
      let docWidth: number, docHeight: number;

      if (uploadedFile) {
        const docElement = pdfContainerRef.current.querySelector('canvas, img');
        if (docElement) {
          docWidth = docElement.clientWidth;
          docHeight = docElement.clientHeight;
        } else {
          docWidth = pdfContainerRef.current.clientWidth;
          docHeight = pdfContainerRef.current.clientHeight;
        }
      } else {
        const clickArea = pdfContainerRef.current.querySelector(
          '[data-click-area="true"]'
        ) as HTMLElement;
        if (clickArea) {
          docWidth = clickArea.clientWidth;
          docHeight = clickArea.clientHeight;
        } else {
          docWidth = pdfContainerRef.current.clientWidth;
          docHeight = Math.max(pdfContainerRef.current.clientHeight, 600);
        }
      }

      // Calculate current field position from percentage
      const fieldX = (field.xPercent / 100) * docWidth;
      const fieldY = (field.yPercent / 100) * docHeight;

      setDragOffset({
        x: touch.clientX - rect.left - fieldX + scrollLeft,
        y: touch.clientY - rect.top - fieldY + scrollTop
      });
    }
  };

  // Enhanced mouse move with proper coordinate handling
  const handleFieldMouseMove = useCallback(
    (event: React.MouseEvent<HTMLDivElement>) => {
      if (
        !draggingFieldId ||
        !dragOffset ||
        !pdfContainerRef.current ||
        !isDraggingField ||
        !initialScrollPos
      )
        return;
      event.preventDefault();

      const rect = pdfContainerRef.current.getBoundingClientRect();
      const currentScrollTop = pdfContainerRef.current.scrollTop;
      const currentScrollLeft = pdfContainerRef.current.scrollLeft;

      const scrollDeltaX = currentScrollLeft - initialScrollPos.x;
      const scrollDeltaY = currentScrollTop - initialScrollPos.y;

      // Get proper container dimensions
      let docWidth: number, docHeight: number;

      if (uploadedFile) {
        const docElement = pdfContainerRef.current.querySelector('canvas, img');
        if (docElement) {
          docWidth = docElement.clientWidth;
          docHeight = docElement.clientHeight;
        } else {
          docWidth = pdfContainerRef.current.clientWidth;
          docHeight = pdfContainerRef.current.clientHeight;
        }
      } else {
        const clickArea = pdfContainerRef.current.querySelector(
          '[data-click-area="true"]'
        ) as HTMLElement;
        if (clickArea) {
          docWidth = clickArea.clientWidth;
          docHeight = clickArea.clientHeight;
        } else {
          docWidth = pdfContainerRef.current.clientWidth;
          docHeight = Math.max(pdfContainerRef.current.clientHeight, 600);
        }
      }

      // Calculate new position in pixels relative to document
      const newX = event.clientX - rect.left - dragOffset.x + currentScrollLeft - scrollDeltaX;
      const newY = event.clientY - rect.top - dragOffset.y + currentScrollTop - scrollDeltaY;

      // Constrain within document bounds
      const field = signatureFields.find((f) => f.id === draggingFieldId);
      const fieldWidth = field?.widthPercent ? (field.widthPercent / 100) * docWidth : 100;
      const fieldHeight = field?.heightPercent ? (field.heightPercent / 100) * docHeight : 25;
      const constrainedX = Math.max(0, Math.min(newX, docWidth - fieldWidth));
      const constrainedY = Math.max(0, Math.min(newY, docHeight - fieldHeight));

      // Convert to percent-based coordinates
      const xPercent = (constrainedX / docWidth) * 100;
      const yPercent = (constrainedY / docHeight) * 100;

      // Use requestAnimationFrame for smoother updates
      window.requestAnimationFrame(() => {
        setSignatureFields((prevFields: SignatureField[]) =>
          prevFields.map((field: SignatureField) =>
            field.id === draggingFieldId
              ? {
                  ...field,
                  xPercent,
                  yPercent,
                  x: constrainedX,
                  y: constrainedY
                }
              : field
          )
        );
      });
    },
    [
      draggingFieldId,
      dragOffset,
      scale,
      isDraggingField,
      signatureFields,
      initialScrollPos,
      uploadedFile,
      setSignatureFields
    ]
  );

  // Enhanced touch move handler
  const handleFieldTouchMove = useCallback(
    (event: React.TouchEvent<HTMLDivElement>) => {
      if (
        !draggingFieldId ||
        !dragOffset ||
        !pdfContainerRef.current ||
        !isDraggingField ||
        !initialScrollPos
      )
        return;
      event.preventDefault();

      const touch = event.touches[0];
      const container = pdfContainerRef.current;
      const rect = container.getBoundingClientRect();
      const currentScrollTop = container.scrollTop;
      const currentScrollLeft = container.scrollLeft;

      const scrollDeltaX = currentScrollLeft - initialScrollPos.x;
      const scrollDeltaY = currentScrollTop - initialScrollPos.y;

      // Get proper container dimensions
      let docWidth: number, docHeight: number;

      if (uploadedFile) {
        const docElement = container.querySelector('canvas, img');
        if (docElement) {
          docWidth = docElement.clientWidth;
          docHeight = docElement.clientHeight;
        } else {
          docWidth = container.clientWidth;
          docHeight = container.clientHeight;
        }
      } else {
        const clickArea = container.querySelector('[data-click-area="true"]') as HTMLElement;
        if (clickArea) {
          docWidth = clickArea.clientWidth;
          docHeight = clickArea.clientHeight;
        } else {
          docWidth = container.clientWidth;
          docHeight = Math.max(container.clientHeight, 600);
        }
      }

      // Calculate new position in pixels relative to document
      const newX = touch.clientX - rect.left - dragOffset.x + currentScrollLeft - scrollDeltaX;
      const newY = touch.clientY - rect.top - dragOffset.y + currentScrollTop - scrollDeltaY;

      // Constrain within document bounds
      const field = signatureFields.find((f) => f.id === draggingFieldId);
      const fieldWidth = field?.widthPercent ? (field.widthPercent / 100) * docWidth : 100;
      const fieldHeight = field?.heightPercent ? (field.heightPercent / 100) * docHeight : 25;
      const constrainedX = Math.max(0, Math.min(newX, docWidth - fieldWidth));
      const constrainedY = Math.max(0, Math.min(newY, docHeight - fieldHeight));

      // Convert to percent-based coordinates
      const xPercent = (constrainedX / docWidth) * 100;
      const yPercent = (constrainedY / docHeight) * 100;

      window.requestAnimationFrame(() => {
        setSignatureFields((prevFields: SignatureField[]) =>
          prevFields.map((field: SignatureField) =>
            field.id === draggingFieldId
              ? {
                  ...field,
                  xPercent,
                  yPercent,
                  x: constrainedX,
                  y: constrainedY
                }
              : field
          )
        );
      });
    },
    [
      draggingFieldId,
      dragOffset,
      scale,
      isDraggingField,
      signatureFields,
      initialScrollPos,
      uploadedFile,
      setSignatureFields
    ]
  );

  const handleFieldMouseUp = useCallback(() => {
    setDraggingFieldId(null);
    setDragOffset(null);
    setIsDraggingField(false);
    setInitialScrollPos(null);
  }, []);

  useEffect(() => {
    if (isDraggingField) {
      const handleGlobalMouseMove = (e: MouseEvent) => {
        if (!draggingFieldId || !dragOffset || !pdfContainerRef.current || !initialScrollPos)
          return;

        const rect = pdfContainerRef.current.getBoundingClientRect();
        const currentScrollTop = pdfContainerRef.current.scrollTop;
        const currentScrollLeft = pdfContainerRef.current.scrollLeft;

        const scrollDeltaX = currentScrollLeft - initialScrollPos.x;
        const scrollDeltaY = currentScrollTop - initialScrollPos.y;

        // Get proper dimensions
        let docWidth: number, docHeight: number;

        if (uploadedFile) {
          const docElement = pdfContainerRef.current.querySelector('canvas, img');
          if (docElement) {
            docWidth = docElement.clientWidth;
            docHeight = docElement.clientHeight;
          } else {
            docWidth = pdfContainerRef.current.clientWidth;
            docHeight = pdfContainerRef.current.clientHeight;
          }
        } else {
          const clickArea = pdfContainerRef.current.querySelector(
            '[data-click-area="true"]'
          ) as HTMLElement;
          if (clickArea) {
            docWidth = clickArea.clientWidth;
            docHeight = clickArea.clientHeight;
          } else {
            docWidth = pdfContainerRef.current.clientWidth;
            docHeight = Math.max(pdfContainerRef.current.clientHeight, 600);
          }
        }

        const newX = e.clientX - rect.left - dragOffset.x + currentScrollLeft - scrollDeltaX;
        const newY = e.clientY - rect.top - dragOffset.y + currentScrollTop - scrollDeltaY;

        const field = signatureFields.find((f) => f.id === draggingFieldId);
        const fieldWidth = field?.widthPercent ? (field.widthPercent / 100) * docWidth : 100;
        const fieldHeight = field?.heightPercent ? (field.heightPercent / 100) * docHeight : 25;

        const constrainedX = Math.max(0, Math.min(newX, docWidth - fieldWidth));
        const constrainedY = Math.max(0, Math.min(newY, docHeight - fieldHeight));

        const xPercent = (constrainedX / docWidth) * 100;
        const yPercent = (constrainedY / docHeight) * 100;

        setSignatureFields((prevFields: SignatureField[]) =>
          prevFields.map((field: SignatureField) =>
            field.id === draggingFieldId
              ? {
                  ...field,
                  xPercent,
                  yPercent,
                  x: constrainedX,
                  y: constrainedY
                }
              : field
          )
        );
      };

      const handleGlobalTouchMove = (e: TouchEvent) => {
        if (!draggingFieldId || !dragOffset || !pdfContainerRef.current || !initialScrollPos)
          return;

        const touch = e.touches[0];
        const container = pdfContainerRef.current;
        const rect = container.getBoundingClientRect();
        const currentScrollTop = container.scrollTop;
        const currentScrollLeft = container.scrollLeft;

        const scrollDeltaX = currentScrollLeft - initialScrollPos.x;
        const scrollDeltaY = currentScrollTop - initialScrollPos.y;

        // Get proper dimensions
        let docWidth: number, docHeight: number;

        if (uploadedFile) {
          const docElement = container.querySelector('canvas, img');
          if (docElement) {
            docWidth = docElement.clientWidth;
            docHeight = docElement.clientHeight;
          } else {
            docWidth = container.clientWidth;
            docHeight = container.clientHeight;
          }
        } else {
          const clickArea = container.querySelector('[data-click-area="true"]') as HTMLElement;
          if (clickArea) {
            docWidth = clickArea.clientWidth;
            docHeight = clickArea.clientHeight;
          } else {
            docWidth = container.clientWidth;
            docHeight = Math.max(container.clientHeight, 600);
          }
        }

        const newX = touch.clientX - rect.left - dragOffset.x + currentScrollLeft - scrollDeltaX;
        const newY = touch.clientY - rect.top - dragOffset.y + currentScrollTop - scrollDeltaY;

        const field = signatureFields.find((f) => f.id === draggingFieldId);
        const fieldWidth = field?.widthPercent ? (field.widthPercent / 100) * docWidth : 100;
        const fieldHeight = field?.heightPercent ? (field.heightPercent / 100) * docHeight : 25;

        const constrainedX = Math.max(0, Math.min(newX, docWidth - fieldWidth));
        const constrainedY = Math.max(0, Math.min(newY, docHeight - fieldHeight));

        const xPercent = (constrainedX / docWidth) * 100;
        const yPercent = (constrainedY / docHeight) * 100;

        setSignatureFields((prevFields: SignatureField[]) =>
          prevFields.map((field: SignatureField) =>
            field.id === draggingFieldId
              ? {
                  ...field,
                  xPercent,
                  yPercent,
                  x: constrainedX,
                  y: constrainedY
                }
              : field
          )
        );
      };

      const handleGlobalMouseUp = () => {
        handleFieldMouseUp();
      };

      document.addEventListener('mousemove', handleGlobalMouseMove);
      document.addEventListener('mouseup', handleGlobalMouseUp);
      document.addEventListener('touchmove', handleGlobalTouchMove, { passive: false });
      document.addEventListener('touchend', handleGlobalMouseUp);

      return () => {
        document.removeEventListener('mousemove', handleGlobalMouseMove);
        document.removeEventListener('mouseup', handleGlobalMouseUp);
        document.removeEventListener('touchmove', handleGlobalTouchMove);
        document.removeEventListener('touchend', handleGlobalMouseUp);
      };
    }
  }, [
    isDraggingField,
    draggingFieldId,
    dragOffset,
    scale,
    handleFieldMouseUp,
    signatureFields,
    initialScrollPos,
    uploadedFile,
    setSignatureFields
  ]);

  // Prevent scroll during drag on mobile
  useEffect(() => {
    if (isDraggingField && isMobile && pdfContainerRef.current) {
      const container = pdfContainerRef.current;
      const originalOverflow = container.style.overflow;
      const originalTouchAction = document.body.style.touchAction;

      container.style.overflow = 'hidden';
      document.body.style.touchAction = 'none';

      return () => {
        container.style.overflow = originalOverflow;
        document.body.style.touchAction = originalTouchAction;
      };
    }
  }, [isDraggingField, isMobile]);

  const removeSignatureField = (fieldId: string) => {
    setSignatureFields(signatureFields.filter((field) => field.id !== fieldId));
    setFieldRequirements((prev) => {
      const updated = { ...prev };
      delete updated[fieldId];
      return updated;
    });
  };

  const toggleFieldRequirement = (fieldId: string) => {
    setFieldRequirements((prev) => ({
      ...prev,
      [fieldId]: !prev[fieldId]
    }));
    setSignatureFields((prev: SignatureField[]) =>
      prev.map((field: SignatureField) =>
        field.id === fieldId ? { ...field, isRequired: !fieldRequirements[fieldId] } : field
      )
    );
  };

  const toggleFullScreen = () => setFullScreenPdf((prev) => !prev);

  // Enhanced signature field rendering with proper positioning
  const renderSignatureField = useCallback(
    (field: SignatureField) => {
      const config = fieldTypes.find((f) => f.label === field.fieldLabel) || fieldTypes[0];
      const isBeingDragged = draggingFieldId === field.id;

      // Get proper container dimensions
      let docWidth: number, docHeight: number;

      if (uploadedFile) {
        if (pdfContainerRef.current) {
          const docElement = pdfContainerRef.current.querySelector('canvas, img');
          if (docElement) {
            docWidth = docElement.clientWidth;
            docHeight = docElement.clientHeight;
          } else {
            docWidth = pdfContainerRef.current.clientWidth;
            docHeight = pdfContainerRef.current.clientHeight;
          }
        } else {
          docWidth = 800;
          docHeight = 600;
        }
      } else {
        if (pdfContainerRef.current) {
          const clickArea = pdfContainerRef.current.querySelector(
            '[data-click-area="true"]'
          ) as HTMLElement;
          if (clickArea) {
            docWidth = clickArea.clientWidth;
            docHeight = clickArea.clientHeight;
          } else {
            docWidth = pdfContainerRef.current.clientWidth;
            docHeight = Math.max(pdfContainerRef.current.clientHeight, 600);
          }
        } else {
          docWidth = 800;
          docHeight = 600;
        }
      }

      // Calculate position from percentage
      const fieldWidth = (field.widthPercent / 100) * docWidth;
      const fieldHeight = (field.heightPercent / 100) * docHeight;
      const left = (field.xPercent / 100) * docWidth;
      const top = (field.yPercent / 100) * docHeight;
      const isRequired = fieldRequirements[field.id] || false;

      return (
        <Tooltip
          key={field.id}
          title={`${config.label} (${field.type}) - ${
            isRequired ? 'Required' : 'Optional'
          } - Drag to move, click buttons to modify`}
          placement="top"
        >
          <Box
            sx={{
              position: 'absolute',
              left,
              top,
              bgcolor: isBeingDragged ? 'rgba(25,118,210,0.1)' : 'rgba(255,255,255,0.95)',
              border: `2px solid ${config.color}`,
              borderRadius: 1,
              p: isMobile ? 0.5 : 0.75,
              width: fieldWidth,
              height: fieldHeight,
              cursor: isBeingDragged ? 'grabbing' : 'grab',
              zIndex: isBeingDragged ? 1000 : 100,
              boxShadow: isBeingDragged
                ? '0 8px 16px rgba(0,0,0,0.3)'
                : '0 2px 8px rgba(0,0,0,0.15)',
              transition: isBeingDragged ? 'none' : 'all 0.2s ease',
              '&:hover': {
                boxShadow: '0 4px 12px rgba(0,0,0,0.25)',
                '& .field-actions': { opacity: 1 }
              },
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexDirection: config.fieldKey === 'checkbox' ? 'row' : 'column',
              userSelect: 'none'
            }}
            onMouseDown={(e) => handleFieldMouseDown(field.id, e)}
            onTouchStart={(e) => handleFieldTouchStart(field.id, e)}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: config.fieldKey === 'checkbox' ? 0.5 : 0.75,
                flexDirection: 'row',
                pointerEvents: 'none'
              }}
            >
              <Box sx={{ fontSize: isMobile ? '12px' : '14px', color: config.color }}>
                {React.cloneElement(config.icon as React.ReactElement<any>, {
                  fontSize: 'inherit'
                })}
              </Box>
              {config.fieldKey !== 'checkbox' && (
                <Typography
                  variant="caption"
                  sx={{
                    fontSize: isMobile ? '8px' : '10px',
                    fontWeight: 600,
                    color: config.color,
                    lineHeight: 1.2,
                    display: 'flex',
                    alignItems: 'center'
                  }}
                >
                  {config.label}{' '}
                  <span style={{ color: '#999', fontWeight: 400 }}>({field.type})</span>
                </Typography>
              )}
            </Box>

            {isRequired && (
              <StarIcon
                sx={{
                  fontSize: '10px',
                  color: '#f44336',
                  position: 'absolute',
                  top: -4,
                  right: -4
                }}
              />
            )}

            <DragIcon
              sx={{
                fontSize: isMobile ? '10px' : '12px',
                color: config.color,
                opacity: 0.6,
                position: 'absolute',
                bottom: 2,
                right: 2,
                pointerEvents: 'none'
              }}
            />

            <Box
              className="field-actions"
              sx={{
                position: 'absolute',
                top: -8,
                right: -8,
                opacity: 0,
                transition: 'opacity 0.2s ease',
                display: 'flex',
                gap: 0.5
              }}
            >
              <IconButton
                size="small"
                sx={{
                  width: 18,
                  height: 18,
                  bgcolor: isRequired ? 'warning.main' : 'info.main',
                  color: 'white',
                  fontSize: '10px',
                  '&:hover': {
                    bgcolor: isRequired ? 'warning.dark' : 'info.dark',
                    transform: 'scale(1.1)'
                  }
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  toggleFieldRequirement(field.id);
                }}
                title={isRequired ? 'Make Optional' : 'Make Required'}
              >
                <StarIcon sx={{ fontSize: '8px' }} />
              </IconButton>
              <IconButton
                size="small"
                sx={{
                  width: 18,
                  height: 18,
                  bgcolor: 'error.main',
                  color: 'white',
                  fontSize: '10px',
                  '&:hover': {
                    bgcolor: 'error.dark',
                    transform: 'scale(1.1)'
                  }
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  removeSignatureField(field.id);
                }}
              >
                <CloseIcon sx={{ fontSize: '8px' }} />
              </IconButton>
            </Box>
          </Box>
        </Tooltip>
      );
    },
    [
      fieldRequirements,
      draggingFieldId,
      isMobile,
      handleFieldMouseDown,
      handleFieldTouchStart,
      toggleFieldRequirement,
      removeSignatureField,
      pdfRenderTrigger,
      uploadedFile
    ]
  );

  // Enhanced renderPageThumbnails with fixed positioning
  const renderPageThumbnails = () => {
    if (!uploadedFile || uploadedFile.type !== 'pdf' || numPages <= 1) return null;

    return (
      <Box
        sx={{
          width: isMobile ? 80 : 100,
          minWidth: isMobile ? 80 : 100,
          borderLeft: '1px solid #e0e0e0',
          bgcolor: '#fafafa',
          overflowY: 'auto',
          overflowX: 'hidden',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          gap: 1,
          p: 1,
          '::-webkit-scrollbar': {
            width: '6px'
          },
          '::-webkit-scrollbar-track': {
            background: '#f1f1f1',
            borderRadius: '3px'
          },
          '::-webkit-scrollbar-thumb': {
            background: '#c1c1c1',
            borderRadius: '3px',
            '&:hover': {
              background: '#a8a8a8'
            }
          }
        }}
      >
        <Typography
          variant="caption"
          sx={{
            fontSize: isMobile ? '8px' : '10px',
            fontWeight: 600,
            textAlign: 'center',
            color: '#666',
            mb: 0.5
          }}
        >
          Pages ({numPages})
        </Typography>

        {Array.from({ length: numPages }, (_, index) => {
          const pageNum = index + 1;
          const isCurrentPage = currentPage === pageNum;
          const fieldsOnPage = signatureFields.filter(
            (field) => field.pageNumber === pageNum
          ).length;

          return (
            <Box
              key={pageNum}
              onClick={() => setCurrentPage(pageNum)}
              sx={{
                position: 'relative',
                cursor: 'pointer',
                border: isCurrentPage ? '2px solid #1976d2' : '1px solid #ddd',
                borderRadius: 1,
                bgcolor: isCurrentPage ? '#e3f2fd' : 'white',
                overflow: 'hidden',
                transition: 'all 0.2s ease',
                '&:hover': {
                  borderColor: '#1976d2',
                  transform: 'scale(1.02)',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
                },
                width: isMobile ? 60 : 80,
                height: isMobile ? 84 : 112,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                mx: 'auto',
                flexShrink: 0
              }}
            >
              <Document file={uploadedFile.preview} onLoadSuccess={() => {}}>
                <Page
                  pageNumber={pageNum}
                  width={isMobile ? 50 : 70}
                  height={isMobile ? 70 : 98}
                  renderAnnotationLayer={false}
                  renderTextLayer={false}
                />
              </Document>

              <Box
                sx={{
                  position: 'absolute',
                  bottom: 2,
                  left: 2,
                  bgcolor: isCurrentPage ? '#1976d2' : 'rgba(0,0,0,0.7)',
                  color: 'white',
                  px: 0.5,
                  py: 0.25,
                  borderRadius: 0.5,
                  fontSize: isMobile ? '8px' : '10px',
                  fontWeight: 600,
                  lineHeight: 1,
                  minWidth: 16,
                  textAlign: 'center'
                }}
              >
                {pageNum}
              </Box>

              {fieldsOnPage > 0 && (
                <Box
                  sx={{
                    position: 'absolute',
                    top: 2,
                    right: 2,
                    bgcolor: '#ff9800',
                    color: 'white',
                    minWidth: 16,
                    height: 16,
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: isMobile ? '8px' : '9px',
                    fontWeight: 600,
                    lineHeight: 1
                  }}
                >
                  {fieldsOnPage}
                </Box>
              )}
            </Box>
          );
        })}
      </Box>
    );
  };

  // Render empty template with grid background
  const renderEmptyTemplate = () => {
    const currentPageFields = signatureFields.filter((field) => field.pageNumber === 1);

    return (
      <Fade in={!uploadedFile}>
        <Paper
          elevation={2}
          sx={{
            p: 1,
            mt: 1,
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            height: isMobile ? 'calc(100vh - 200px)' : 'calc(100vh - 160px)'
          }}
        >
          {/* Header */}
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 1, width: '100%' }}>
            <GridIcon sx={{ color: '#217346', mr: 1, fontSize: isMobile ? 16 : 20 }} />
            <Box sx={{ ml: 0.5, flex: 1, overflow: 'hidden' }}>
              <Typography
                variant="caption"
                sx={{
                  fontSize: isMobile ? '10px' : '12px',
                  fontWeight: 600
                }}
              >
                Empty Template
              </Typography>
              <Typography
                variant="caption"
                color="text.secondary"
                sx={{
                  display: 'block',
                  fontSize: isMobile ? '8px' : '10px'
                }}
              >
                {signatureFields.length} field{signatureFields.length !== 1 ? 's' : ''} added
              </Typography>
            </Box>
            <Button
              variant="outlined"
              component="label"
              size="small"
              startIcon={<UploadIcon sx={{ fontSize: isMobile ? 14 : 16 }} />}
              sx={{
                fontSize: isMobile ? '8px' : '10px',
                borderColor: '#217346',
                color: '#217346',
                '&:hover': {
                  backgroundColor: '#e8f5e9',
                  borderColor: '#1a5d37'
                }
              }}
            >
              Add Document
              <input
                ref={fileInputRef}
                type="file"
                accept=".pdf,.doc,.docx,.jpg,.jpeg,.png,.gif,.webp"
                hidden
                onChange={handleUpload}
              />
            </Button>
          </Box>

          {/* Interactive container */}
          <Box
            sx={{
              flex: 1,
              overflow: 'auto',
              bgcolor: '#fafafa',
              border: `1px solid #e0e0e0`,
              borderRadius: 0.5,
              position: 'relative',
              userSelect: 'none',
              width: '100%',
              backgroundImage: `
                linear-gradient(rgba(33, 115, 70, 0.1) 1px, transparent 1px),
                linear-gradient(90deg, rgba(33, 115, 70, 0.1) 1px, transparent 1px)
              `,
              backgroundSize: '20px 20px'
            }}
            ref={pdfContainerRef}
            onMouseMove={handleFieldMouseMove}
            onMouseUp={handleFieldMouseUp}
            onTouchMove={handleFieldTouchMove}
            onTouchEnd={handleFieldMouseUp}
          >
            <Box
              data-click-area="true"
              sx={{
                position: 'relative',
                width: '100%',
                height: '100%',
                minHeight: '600px',
                cursor:
                  selectedFieldType || selectedFieldTypes.length > 0
                    ? 'crosshair'
                    : isDraggingField
                    ? 'grabbing'
                    : 'default',
                background:
                  selectedFieldType || selectedFieldTypes.length > 0
                    ? 'repeating-linear-gradient(45deg,transparent,transparent 8px,rgba(33,115,70,0.05) 8px,rgba(33,115,70,0.05) 16px)'
                    : 'transparent',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
              onClick={handlePageClick}
            >
              {(selectedFieldType || selectedFieldTypes.length > 0) && (
                <Box
                  sx={{
                    position: 'absolute',
                    top: 4,
                    left: 4,
                    bgcolor: '#217346',
                    color: 'white',
                    px: 1,
                    py: 0.5,
                    borderRadius: 0.5,
                    zIndex: 10
                  }}
                >
                  <Typography variant="caption" sx={{ fontSize: isMobile ? '9px' : '10px' }}>
                    Click to place{' '}
                    {selectedFieldType
                      ? getFieldConfig(selectedFieldType)?.label
                      : `${selectedFieldTypes.length} fields`}
                  </Typography>
                </Box>
              )}

              {/* Empty state message */}
              {signatureFields.length === 0 &&
                !selectedFieldType &&
                selectedFieldTypes.length === 0 && (
                  <Box sx={{ textAlign: 'center', p: 2 }}>
                    <GridIcon sx={{ fontSize: 48, color: '#ccc', mb: 1 }} />
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{ mb: 1, fontSize: isMobile ? '11px' : '13px' }}
                    >
                      Empty Template Canvas
                    </Typography>
                    <Typography
                      variant="caption"
                      color="text.secondary"
                      sx={{ fontSize: isMobile ? '9px' : '11px' }}
                    >
                      Select a field type from the panel and click here to place it
                    </Typography>
                  </Box>
                )}

              {/* Render signature fields */}
              {currentPageFields.map((field) => renderSignatureField(field))}
            </Box>
          </Box>
        </Paper>
      </Fade>
    );
  };

  // File preview rendering
  const renderFilePreview = () => {
    if (!uploadedFile) {
      return renderEmptyTemplate();
    }

    const { file, preview, type } = uploadedFile;
    const currentPageFields = signatureFields.filter((field) => field.pageNumber === currentPage);

    if (type !== 'pdf') {
      return (
        <Fade in={!!uploadedFile}>
          <Paper
            elevation={2}
            sx={{
              p: 1,
              mt: 1,
              width: '100%',
              display: 'flex',
              flexDirection: 'column',
              height: isMobile ? 'calc(100vh - 200px)' : 'calc(100vh - 160px)'
            }}
          >
            {/* File info header */}
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1, width: '100%' }}>
              {getFileIcon(type || 'document')}
              <Box sx={{ ml: 1, flex: 1, overflow: 'hidden' }}>
                <Typography
                  variant="caption"
                  sx={{
                    fontSize: isMobile ? '10px' : '12px',
                    fontWeight: 600
                  }}
                >
                  {file && file.name && file.name.length > 40
                    ? `${file.name.substring(0, 40)}...`
                    : file?.name || 'Unknown file'}
                </Typography>
                <Typography
                  variant="caption"
                  color="text.secondary"
                  sx={{
                    display: 'block',
                    fontSize: isMobile ? '8px' : '10px'
                  }}
                >
                  {file?.size ? (file.size / 1024 / 1024).toFixed(2) : '0'} MB •{' '}
                  {type?.toUpperCase() || 'UNKNOWN'}
                </Typography>
              </Box>
              <IconButton onClick={removeFile} color="error" size="small">
                <DeleteIcon sx={{ fontSize: 16 }} />
              </IconButton>
            </Box>

            {/* Interactive container */}
            <Box
              sx={{
                flex: 1,
                overflow: 'auto',
                bgcolor: '#fafafa',
                border: `1px solid #e0e0e0`,
                borderRadius: 0.5,
                position: 'relative',
                userSelect: 'none',
                width: '100%'
              }}
              ref={pdfContainerRef}
              onMouseMove={handleFieldMouseMove}
              onMouseUp={handleFieldMouseUp}
              onTouchMove={handleFieldTouchMove}
              onTouchEnd={handleFieldMouseUp}
            >
              <Box
                sx={{
                  position: 'relative',
                  width: '100%',
                  height: '100%',
                  minHeight: '100%',
                  cursor:
                    selectedFieldType || selectedFieldTypes.length > 0
                      ? 'crosshair'
                      : isDraggingField
                      ? 'grabbing'
                      : 'default',
                  background:
                    selectedFieldType || selectedFieldTypes.length > 0
                      ? 'repeating-linear-gradient(45deg,transparent,transparent 8px,rgba(0,0,255,0.05) 8px,rgba(0,0,255,0.05) 16px)'
                      : 'transparent',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
                onClick={handlePageClick}
              >
                {(selectedFieldType || selectedFieldTypes.length > 0) && (
                  <Box
                    sx={{
                      position: 'absolute',
                      top: 8,
                      left: 8,
                      bgcolor: 'primary.main',
                      color: 'white',
                      px: 1,
                      py: 0.5,
                      borderRadius: 0.5,
                      zIndex: 10
                    }}
                  >
                    <Typography variant="caption" sx={{ fontSize: '10px' }}>
                      Click to place{' '}
                      {selectedFieldType
                        ? getFieldConfig(selectedFieldType)?.label
                        : `${selectedFieldTypes.length} fields`}
                    </Typography>
                  </Box>
                )}

                {/* Image or document preview */}
                {type === 'image' ? (
                  <img
                    src={preview}
                    alt="Preview"
                    style={{
                      maxWidth: '100%',
                      maxHeight: '100%',
                      width: 'auto',
                      height: 'auto',
                      display: 'block',
                      objectFit: 'contain'
                    }}
                    onLoad={handlePageRenderSuccess}
                  />
                ) : (
                  <Box sx={{ textAlign: 'center', p: 2 }}>
                    {getFileIcon(type || 'document')}
                    <Typography variant="caption" sx={{ display: 'block', mt: 1 }}>
                      Preview not available for this file type
                    </Typography>
                  </Box>
                )}

                {/* Render signature fields */}
                {signatureFields
                  .filter((field) => field.pageNumber === 1)
                  .map((field) => renderSignatureField(field))}
              </Box>
            </Box>
          </Paper>
        </Fade>
      );
    }

    // PDF rendering with THUMBNAIL NAVIGATION on RIGHT side
    return (
      <Fade in={!!uploadedFile}>
        <Paper
          elevation={2}
          sx={{
            p: isMobile ? 0.5 : 1,
            mt: isMobile ? 0.5 : 1,
            position: 'relative',
            width: '100%',
            height: isMobile ? 'calc(100vh - 200px)' : 'calc(100vh - 160px)'
          }}
        >
          {/* File info header */}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              mb: isMobile ? 0.5 : 1,
              minHeight: isMobile ? 30 : 40
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', flex: 1 }}>
              {getFileIcon(type || 'pdf')}
              <Box sx={{ ml: 1, overflow: 'hidden' }}>
                <Typography
                  variant="caption"
                  sx={{
                    fontSize: isMobile ? '10px' : '12px',
                    fontWeight: 600,
                    display: 'block'
                  }}
                >
                  {file?.name && file.name.length > 40
                    ? `${file.name.substring(0, 40)}...`
                    : file?.name || 'Unknown file'}
                </Typography>
                <Typography
                  variant="caption"
                  color="text.secondary"
                  sx={{ fontSize: isMobile ? '8px' : '10px' }}
                >
                  {file?.size ? (file.size / 1024 / 1024).toFixed(2) : '0'} MB • Page {currentPage}/
                  {numPages}
                </Typography>
              </Box>
            </Box>
            <IconButton onClick={removeFile} color="error" size="small">
              <DeleteIcon sx={{ fontSize: 16 }} />
            </IconButton>
          </Box>

          {/* PDF controls */}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              mb: isMobile ? 0.5 : 1,
              minHeight: isMobile ? 30 : 35
            }}
          >
            {/* Show page dropdown only on mobile for space */}
            {isMobile && (
              <FormControl size="small" sx={{ minWidth: 80 }}>
                <Select
                  value={currentPage.toString()}
                  onChange={(e) => setCurrentPage(Number(e.target.value))}
                  sx={{ fontSize: '10px' }}
                >
                  {Array.from({ length: numPages }, (_, i) => i + 1).map((pageNum) => (
                    <MenuItem key={pageNum} value={pageNum} sx={{ fontSize: '10px' }}>
                      P{pageNum}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}

            {!isMobile && (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Typography variant="caption" sx={{ fontSize: '11px', color: '#666' }}>
                  Page {currentPage} of {numPages}
                </Typography>
              </Box>
            )}

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
              <IconButton
                onClick={() => setScale(Math.max(0.5, scale - 0.1))}
                disabled={scale <= 0.5}
                size="small"
              >
                <ZoomOutIcon sx={{ fontSize: isMobile ? 14 : 16 }} />
              </IconButton>
              <Typography
                variant="caption"
                sx={{ minWidth: '30px', textAlign: 'center', fontSize: isMobile ? '8px' : '10px' }}
              >
                {Math.round(scale * 100)}%
              </Typography>
              <IconButton
                onClick={() => setScale(Math.min(2.0, scale + 0.1))}
                disabled={scale >= 2.0}
                size="small"
              >
                <ZoomInIcon sx={{ fontSize: isMobile ? 14 : 16 }} />
              </IconButton>
              <IconButton onClick={toggleFullScreen} size="small">
                {fullScreenPdf ? (
                  <FullscreenExitIcon sx={{ fontSize: isMobile ? 14 : 16 }} />
                ) : (
                  <FullscreenIcon sx={{ fontSize: isMobile ? 14 : 16 }} />
                )}
              </IconButton>
            </Box>
          </Box>

          {/* MAIN CONTENT: PDF Viewer + Thumbnail Navigation (Thumbnails on RIGHT) */}
          <Box
            sx={{
              border: `1px solid #e0e0e0`,
              borderRadius: 0.5,
              bgcolor: '#fafafa',
              position: 'relative',
              overflow: 'hidden',
              height: 'calc(100% - 80px)',
              width: '100%',
              display: 'flex'
            }}
          >
            {/* Right panel: Page thumbnails (only for desktop and multi-page PDFs) */}
            {!isMobile && renderPageThumbnails()}
            {/* Main PDF viewer - LEFT SIDE */}
            <Box
              sx={{
                flex: 1,
                position: 'relative',
                overflow: 'auto',
                userSelect: 'none'
              }}
              ref={pdfContainerRef}
              onMouseMove={handleFieldMouseMove}
              onMouseUp={handleFieldMouseUp}
              onTouchMove={handleFieldTouchMove}
              onTouchEnd={handleFieldMouseUp}
            >
              <Box
                sx={{
                  position: 'relative',
                  cursor:
                    selectedFieldType || selectedFieldTypes.length > 0
                      ? 'crosshair'
                      : isDraggingField
                      ? 'grabbing'
                      : 'default',
                  background:
                    selectedFieldType || selectedFieldTypes.length > 0
                      ? 'repeating-linear-gradient(45deg,transparent,transparent 8px,rgba(0,0,255,0.05) 8px,rgba(0,0,255,0.05) 16px)'
                      : 'transparent',
                  minHeight: '100%',
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'flex-start',
                  p: 1
                }}
                onClick={handlePageClick}
              >
                {(selectedFieldType || selectedFieldTypes.length > 0) && (
                  <Box
                    sx={{
                      position: 'absolute',
                      top: 4,
                      left: 4,
                      bgcolor: 'primary.main',
                      color: 'white',
                      px: 1,
                      py: 0.5,
                      borderRadius: 0.5,
                      zIndex: 10
                    }}
                  >
                    <Typography variant="caption" sx={{ fontSize: isMobile ? '9px' : '11px' }}>
                      Click to place{' '}
                      {selectedFieldType
                        ? getFieldConfig(selectedFieldType)?.label
                        : `${selectedFieldTypes.length} fields`}
                    </Typography>
                  </Box>
                )}

                {/* PDF with render success callback */}
                <Document
                  file={preview}
                  onLoadSuccess={onDocumentLoadSuccess}
                  onLoadError={() => setPdfError('Failed to load PDF.')}
                >
                  <Page
                    pageNumber={currentPage}
                    scale={scale}
                    width={
                      pdfContainerRef.current?.clientWidth
                        ? pdfContainerRef.current.clientWidth - (isMobile ? 100 : 132)
                        : undefined
                    }
                    renderTextLayer={false}
                    onRenderSuccess={handlePageRenderSuccess}
                  />
                </Document>
                {currentPageFields.map((field) => renderSignatureField(field))}
              </Box>
              {pdfError && (
                <Box
                  sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    bgcolor: 'rgba(0,0,0,0.5)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'white'
                  }}
                >
                  <Typography variant="caption">{pdfError}</Typography>
                </Box>
              )}
            </Box>
          </Box>
        </Paper>
      </Fade>
    );
  };

  const renderMobileFieldSelector = () => (
    <Dialog
      open={showMobileFieldSelector}
      onClose={() => {
        setShowMobileFieldSelector(false);
        setMultiSelectMode(false);
        setSelectedFieldTypes([]);
      }}
      fullScreen={isMobile}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle sx={{ pb: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Typography variant="subtitle2" sx={{ fontSize: '14px' }}>
            Select Document Fields
          </Typography>
          <IconButton
            size="small"
            onClick={() => {
              setShowMobileFieldSelector(false);
              setMultiSelectMode(false);
              setSelectedFieldTypes([]);
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent sx={{ pb: 1 }}>{renderFieldTypeSelector()}</DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            setShowMobileFieldSelector(false);
            setMultiSelectMode(false);
            setSelectedFieldTypes([]);
          }}
          size="small"
        >
          Done
        </Button>
      </DialogActions>
    </Dialog>
  );

  const renderFieldTypeSelector = () => {
    const fieldsByCategory = getFieldsByCategory();
    const categoryNames = {
      signature: 'Signatures',
      personal: 'Personal',
      contact: 'Contact',
      dates: 'Dates',
      other: 'Other'
    };

    return (
      <Box sx={{ mb: 2 }}>
        <Typography
          variant="caption"
          sx={{ fontWeight: 600, mb: 1, display: 'block', fontSize: isMobile ? '10px' : '11px' }}
        >
          Document Fields
        </Typography>
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ mb: 1, display: 'block', fontSize: isMobile ? '8px' : '9px' }}
        >
          Click field type → Click{' '}
          {uploadedFile ? (uploadedFile?.type === 'image' ? 'image' : 'PDF') : 'canvas'} to place →
          Drag to move → Toggle required → X to remove
        </Typography>

        {isMobile && (
          <Box sx={{ mb: 1.5, display: 'flex', alignItems: 'center', gap: 1 }}>
            <FormControlLabel
              control={
                <Switch
                  checked={multiSelectMode}
                  onChange={(e) => {
                    setMultiSelectMode(e.target.checked);
                    if (!e.target.checked) {
                      setSelectedFieldTypes([]);
                    }
                  }}
                  size="small"
                />
              }
              label={
                <Typography variant="caption" sx={{ fontSize: '9px' }}>
                  Multi-select
                </Typography>
              }
            />
            {multiSelectMode && selectedFieldTypes.length > 0 && (
              <Button size="small" variant="contained" sx={{ fontSize: '8px', py: 0.25 }}>
                Place {selectedFieldTypes.length} fields
              </Button>
            )}
          </Box>
        )}

        <Stack spacing={1}>
          {Object.entries(fieldsByCategory).map(([category, fields]) => (
            <Box key={category}>
              <Typography
                variant="caption"
                sx={{
                  fontWeight: 600,
                  mb: 0.5,
                  display: 'block',
                  fontSize: isMobile ? '9px' : '10px',
                  opacity: 0.8
                }}
              >
                {categoryNames[category as keyof typeof categoryNames] || category}
              </Typography>
              <Grid container spacing={0.5}>
                {(fields as any[]).map((fieldConfig) => {
                  const isSelected = multiSelectMode
                    ? selectedFieldTypes.includes(fieldConfig.fieldKey)
                    : selectedFieldType === fieldConfig.fieldKey;

                  return (
                    <Grid item xs={6} key={fieldConfig.fieldKey}>
                      <Tooltip title={fieldConfig.description} placement="top">
                        <Button
                          variant={isSelected ? 'contained' : 'outlined'}
                          onClick={() => addSignatureField(fieldConfig.fieldKey)}
                          sx={{
                            width: '100%',
                            minHeight: isMobile ? 28 : 32,
                            textTransform: 'none',
                            borderColor: fieldConfig.color,
                            color: isSelected ? 'white' : fieldConfig.color,
                            bgcolor: isSelected ? fieldConfig.color : 'transparent',
                            '&:hover': {
                              borderColor: fieldConfig.color,
                              bgcolor: isSelected ? fieldConfig.color : `${fieldConfig.color}10`
                            },
                            fontSize: isMobile ? '8px' : '9px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: 0.25,
                            p: 0.5,
                            position: 'relative'
                          }}
                        >
                          <Box sx={{ fontSize: isMobile ? '10px' : '12px' }}>
                            {React.cloneElement(fieldConfig.icon as React.ReactElement<any>, {
                              fontSize: 'inherit'
                            })}
                          </Box>
                          <span>{fieldConfig.label}</span>
                          {fieldConfig.defaultRequired && (
                            <StarIcon
                              sx={{
                                position: 'absolute',
                                top: -2,
                                right: -2,
                                color: '#f44336',
                                fontSize: '8px'
                              }}
                            />
                          )}
                        </Button>
                      </Tooltip>
                    </Grid>
                  );
                })}
              </Grid>
            </Box>
          ))}
        </Stack>

        {(selectedFieldType || selectedFieldTypes.length > 0) && (
          <Alert
            severity="info"
            sx={{
              mt: 1,
              '& .MuiAlert-message': {
                fontSize: isMobile ? '8px' : '10px'
              }
            }}
          >
            {multiSelectMode && selectedFieldTypes.length > 0 ? (
              <>
                Selected: <strong>{selectedFieldTypes.length} fields</strong>
              </>
            ) : (
              <>
                Selected: <strong>{getFieldConfig(selectedFieldType!).label}</strong>
              </>
            )}
          </Alert>
        )}

        {signatureFields.length > 0 && (
          <Box sx={{ mt: 1.5 }}>
            <Typography
              variant="caption"
              sx={{ mb: 0.5, display: 'block', fontSize: isMobile ? '9px' : '10px' }}
            >
              Placed ({signatureFields.length}) - Required:{' '}
              {Object.values(fieldRequirements).filter(Boolean).length}
            </Typography>
            <Box sx={{ maxHeight: isMobile ? 80 : 100, overflow: 'auto' }}>
              <Stack spacing={0.25}>
                {signatureFields.map((field) => {
                  const config =
                    fieldTypes.find((f: any) => f.label === field.fieldLabel) || fieldTypes[0];
                  const isRequired = fieldRequirements[field.id] || false;
                  return (
                    <Box
                      key={field.id}
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        bgcolor: '#f5f5f5',
                        p: 0.25,
                        borderRadius: 0.5,
                        border: `1px solid ${config.color}15`
                      }}
                    >
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.25, flex: 1 }}>
                        <Box sx={{ fontSize: '8px', color: config.color }}>
                          {React.cloneElement(config.icon as React.ReactElement<any>, {
                            fontSize: 'inherit'
                          })}
                        </Box>
                        <Typography variant="caption" sx={{ fontSize: isMobile ? '7px' : '8px' }}>
                          P{field.pageNumber}: {config.label}
                          {isRequired && (
                            <StarIcon sx={{ fontSize: '8px', color: '#f44336', ml: 0.25 }} />
                          )}
                        </Typography>
                      </Box>
                      <Box sx={{ display: 'flex', gap: 0.25 }}>
                        <FormControlLabel
                          control={
                            <Switch
                              checked={isRequired}
                              onChange={() => toggleFieldRequirement(field.id)}
                              size="small"
                              sx={{
                                padding: 0,
                                '& .MuiSwitch-switchBase': {
                                  padding: 3,
                                  '&.Mui-checked': {
                                    transform: 'translateX(8px)',
                                    color: '#fff',
                                    '& + .MuiSwitch-track': {
                                      backgroundColor: '#f44336',
                                      opacity: 1
                                    }
                                  }
                                },
                                '& .MuiSwitch-thumb': {
                                  width: 10,
                                  height: 10,
                                  boxShadow: 'none'
                                },
                                '& .MuiSwitch-track': {
                                  borderRadius: 12,
                                  height: 14,
                                  width: 28,
                                  opacity: 1,
                                  backgroundColor: '#ccc'
                                }
                              }}
                            />
                          }
                          label=""
                          sx={{ m: 0 }}
                          title={isRequired ? 'Required' : 'Optional'}
                        />
                        <IconButton
                          size="small"
                          color="error"
                          onClick={() => removeSignatureField(field.id)}
                          sx={{ p: 0.25 }}
                        >
                          <DeleteIcon sx={{ fontSize: '8px' }} />
                        </IconButton>
                      </Box>
                    </Box>
                  );
                })}
              </Stack>
            </Box>
          </Box>
        )}
      </Box>
    );
  };

  // Enhanced fullscreen PDF viewer with thumbnails on right
  const renderFullScreenPdfViewer = () => {
    if (!uploadedFile || uploadedFile.type !== 'pdf') return null;
    const currentPageFields = signatureFields.filter((field) => field.pageNumber === currentPage);

    const THUMBNAIL_WIDTH = 100; // Fixed width for thumbnail panel
    const HEADER_PADDING = 16; // Header padding
    const BORDER_WIDTH = 2; // Border width consideration

    return (
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          bgcolor: 'white',
          zIndex: 1300,
          p: 1,
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        {/* Header Controls */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
          <Typography variant="subtitle2" sx={{ fontSize: isMobile ? '12px' : '14px' }}>
            {uploadedFile.file?.name || 'Document'}
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <Typography variant="caption" sx={{ fontSize: '11px', mr: 2 }}>
              Page {currentPage} of {numPages}
            </Typography>
            <IconButton
              onClick={() => setScale(Math.max(0.5, scale - 0.1))}
              disabled={scale <= 0.5}
              size="small"
            >
              <ZoomOutIcon sx={{ fontSize: 16 }} />
            </IconButton>
            <Typography
              variant="caption"
              sx={{
                minWidth: '30px',
                textAlign: 'center',
                fontSize: '9px'
              }}
            >
              {Math.round(scale * 100)}%
            </Typography>
            <IconButton
              onClick={() => setScale(Math.min(2.0, scale + 0.1))}
              disabled={scale >= 2.0}
              size="small"
            >
              <ZoomInIcon sx={{ fontSize: 16 }} />
            </IconButton>
            <IconButton onClick={toggleFullScreen} size="small">
              <FullscreenExitIcon sx={{ fontSize: 16 }} />
            </IconButton>
          </Box>
        </Box>

        {/* Main Content Area - Fullscreen with thumbnail navigation on RIGHT */}
        <Box
          sx={{
            flex: 1,
            overflow: 'hidden',
            bgcolor: '#fafafa',
            border: `1px solid #e0e0e0`,
            borderRadius: 0.5,
            position: 'relative',
            display: 'flex'
          }}
        >
          {/* Main PDF viewer - LEFT SIDE (takes remaining space) */}
          <Box
            sx={{
              flex: 1,
              overflow: 'auto',
              position: 'relative',
              userSelect: 'none'
            }}
            ref={pdfContainerRef}
            onMouseMove={handleFieldMouseMove}
            onMouseUp={handleFieldMouseUp}
            onTouchMove={handleFieldTouchMove}
            onTouchEnd={handleFieldMouseUp}
          >
            <Box
              sx={{
                position: 'relative',
                cursor:
                  selectedFieldType || selectedFieldTypes.length > 0
                    ? 'crosshair'
                    : isDraggingField
                    ? 'grabbing'
                    : 'default',
                background:
                  selectedFieldType || selectedFieldTypes.length > 0
                    ? 'repeating-linear-gradient(45deg,transparent,transparent 8px,rgba(33,115,70,0.05) 8px,rgba(33,115,70,0.05) 16px)'
                    : 'transparent',
                minHeight: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-start',
                p: 1
              }}
              onClick={handlePageClick}
            >
              {(selectedFieldType || selectedFieldTypes.length > 0) && (
                <Box
                  sx={{
                    position: 'absolute',
                    top: 8,
                    left: 8,
                    bgcolor: '#217346',
                    color: 'white',
                    px: 1,
                    py: 0.5,
                    borderRadius: 0.5,
                    zIndex: 10
                  }}
                >
                  <Typography variant="caption" sx={{ fontSize: '10px' }}>
                    Click to place{' '}
                    {selectedFieldType
                      ? getFieldConfig(selectedFieldType)?.label
                      : `${selectedFieldTypes.length} fields`}
                  </Typography>
                </Box>
              )}

              {/* PDF Document with calculated width to fit container */}
              <Document
                file={uploadedFile.preview}
                onLoadSuccess={onDocumentLoadSuccess}
                onLoadError={() => setPdfError('Failed to load PDF in full screen.')}
              >
                <Page
                  pageNumber={currentPage}
                  scale={scale}
                  width={
                    pdfContainerRef.current?.clientWidth
                      ? pdfContainerRef.current.clientWidth - 20 // Account for container padding
                      : window.innerWidth - THUMBNAIL_WIDTH - HEADER_PADDING - BORDER_WIDTH
                  }
                  renderTextLayer={false}
                />
              </Document>
              {currentPageFields.map((field) => renderSignatureField(field))}
            </Box>
          </Box>

          {/* Thumbnail Panel - RIGHT SIDE (fixed width) */}
          <Box
            sx={{
              width: THUMBNAIL_WIDTH,
              minWidth: THUMBNAIL_WIDTH,
              borderLeft: '1px solid #e0e0e0',
              bgcolor: '#fafafa',
              overflowY: 'auto',
              overflowX: 'hidden',
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              gap: 1,
              p: 1,
              // Fix scrollbar styling
              '::-webkit-scrollbar': {
                width: '6px'
              },
              '::-webkit-scrollbar-track': {
                background: '#f1f1f1',
                borderRadius: '3px'
              },
              '::-webkit-scrollbar-thumb': {
                background: '#c1c1c1',
                borderRadius: '3px',
                '&:hover': {
                  background: '#a8a8a8'
                }
              }
            }}
          >
            <Typography
              variant="caption"
              sx={{
                fontSize: isMobile ? '8px' : '10px',
                fontWeight: 600,
                textAlign: 'center',
                color: '#666',
                mb: 0.5
              }}
            >
              Pages ({numPages})
            </Typography>

            {Array.from({ length: numPages }, (_, index) => {
              const pageNum = index + 1;
              const isCurrentPage = currentPage === pageNum;
              const fieldsOnPage = signatureFields.filter(
                (field) => field.pageNumber === pageNum
              ).length;

              return (
                <Box
                  key={pageNum}
                  onClick={() => setCurrentPage(pageNum)}
                  sx={{
                    position: 'relative',
                    cursor: 'pointer',
                    border: isCurrentPage ? '2px solid #217346' : '1px solid #ddd',
                    borderRadius: 1,
                    bgcolor: isCurrentPage ? '#e8f5e9' : 'white',
                    overflow: 'hidden',
                    transition: 'all 0.2s ease',
                    '&:hover': {
                      borderColor: '#217346',
                      transform: 'scale(1.02)',
                      boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
                    },
                    width: isMobile ? 60 : 80,
                    height: isMobile ? 84 : 112,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    mx: 'auto',
                    flexShrink: 0
                  }}
                >
                  <Document file={uploadedFile.preview} onLoadSuccess={() => {}}>
                    <Page
                      pageNumber={pageNum}
                      width={isMobile ? 50 : 70}
                      height={isMobile ? 70 : 98}
                      renderAnnotationLayer={false}
                      renderTextLayer={false}
                    />
                  </Document>

                  {/* Page number badge */}
                  <Box
                    sx={{
                      position: 'absolute',
                      bottom: 2,
                      left: 2,
                      bgcolor: isCurrentPage ? '#217346' : 'rgba(0,0,0,0.7)',
                      color: 'white',
                      px: 0.5,
                      py: 0.25,
                      borderRadius: 0.5,
                      fontSize: isMobile ? '8px' : '10px',
                      fontWeight: 600,
                      lineHeight: 1,
                      minWidth: 16,
                      textAlign: 'center'
                    }}
                  >
                    {pageNum}
                  </Box>

                  {/* Fields count badge */}
                  {fieldsOnPage > 0 && (
                    <Box
                      sx={{
                        position: 'absolute',
                        top: 2,
                        right: 2,
                        bgcolor: '#217346',
                        color: 'white',
                        minWidth: 16,
                        height: 16,
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: isMobile ? '8px' : '9px',
                        fontWeight: 600,
                        lineHeight: 1
                      }}
                    >
                      {fieldsOnPage}
                    </Box>
                  )}
                </Box>
              );
            })}
          </Box>
        </Box>
      </Box>
    );
  };

  return (
    <Box>
      {/* Mobile Field Selector FAB */}
      {isMobile && activeTab === 0 && (
        <Fab
          color="primary"
          size="medium"
          sx={{
            position: 'fixed',
            bottom: 80,
            right: 16,
            zIndex: 1000,
            bgcolor: '#217346',
            '&:hover': { bgcolor: '#1a5d37' }
          }}
          onClick={() => setShowMobileFieldSelector(true)}
        >
          <SettingsIcon />
        </Fab>
      )}

      <Typography
        variant="caption"
        sx={{
          mb: 1,
          color: '#333',
          fontSize: isMobile ? '11px' : '13px',
          fontWeight: 600,
          display: 'block'
        }}
      >
        Step 2: Define Document Fields {!uploadedFile && '(Empty Template)'}
      </Typography>

      {!uploadedFile ? (
        <>
          {isMobile ? (
            <Box>
              <Tabs
                value={activeTab}
                onChange={(e, newValue) => setActiveTab(newValue)}
                variant="fullWidth"
                sx={{ mb: 1 }}
              >
                <Tab label="Canvas" sx={{ fontSize: '10px', minHeight: 36 }} />
                <Tab label="Fields" sx={{ fontSize: '10px', minHeight: 36 }} />
              </Tabs>
              {activeTab === 0 ? renderFilePreview() : <Box>{renderFieldTypeSelector()}</Box>}
            </Box>
          ) : (
            <Grid container spacing={1}>
              <Grid item xs={12} md={9}>
                {renderFilePreview()}
              </Grid>
              <Grid item xs={12} md={3}>
                <Card elevation={1} sx={{ height: 'calc(100vh - 180px)', overflow: 'auto' }}>
                  <CardContent sx={{ p: 1 }}>{renderFieldTypeSelector()}</CardContent>
                </Card>
              </Grid>
            </Grid>
          )}
        </>
      ) : (
        <>
          {fullScreenPdf ? (
            renderFullScreenPdfViewer()
          ) : (
            <>
              {isMobile ? (
                <Box>
                  <Tabs
                    value={activeTab}
                    onChange={(e, newValue) => setActiveTab(newValue)}
                    variant="fullWidth"
                    sx={{ mb: 1 }}
                  >
                    <Tab label="Preview" sx={{ fontSize: '10px', minHeight: 36 }} />
                    <Tab label="Fields" sx={{ fontSize: '10px', minHeight: 36 }} />
                  </Tabs>
                  {activeTab === 0 ? renderFilePreview() : <Box>{renderFieldTypeSelector()}</Box>}
                </Box>
              ) : (
                <Grid container spacing={1}>
                  <Grid item xs={12} md={9}>
                    {renderFilePreview()}
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <Card elevation={1} sx={{ height: 'calc(100vh - 180px)', overflow: 'auto' }}>
                      <CardContent sx={{ p: 1 }}>{renderFieldTypeSelector()}</CardContent>
                    </Card>
                  </Grid>
                </Grid>
              )}
            </>
          )}
        </>
      )}

      {/* Mobile Field Selector Dialog */}
      {renderMobileFieldSelector()}

      {/* Confirmation Dialog */}
      <ConfirmationDialog
        open={showConfirmation}
        title="No Fields Added"
        message="You haven't added any signature fields to the document. Do you want to proceed without adding fields?"
        confirmButtonText="Proceed Anyway"
        confirmButtonColor="secondary"
        onConfirm={() => {
          setShowConfirmation(false);
          onNext();
        }}
        onCancel={() => setShowConfirmation(false)}
        loading={false}
      />

      {/* Navigation */}
      <Box
        sx={{
          mt: 2,
          display: 'flex',
          justifyContent: 'flex-end', // push to right side
          gap: 1, // add spacing between buttons
          alignItems: 'center'
        }}
      >
        <Button
          onClick={onBack}
          sx={{ color: '#666', fontSize: isMobile ? '10px' : '12px' }}
          startIcon={<IoArrowBackCircleOutline size={isMobile ? 12 : 14} />}
          size="small"
        >
          Back
        </Button>

        <Button
          variant="contained"
          onClick={() => {
            if (!signatureFields.length) {
              setShowConfirmation(true);
            } else {
              onNext();
            }
          }}
          sx={{
            minWidth: isMobile ? 80 : 100,
            fontSize: isMobile ? '10px' : '12px',
            backgroundColor: '#217346',
            '&:hover': { backgroundColor: '#1a5d37' }
          }}
          size="small"
        >
          Next
        </Button>
      </Box>
    </Box>
  );
};

export default DocumentEditingStep;
